<div class="f-14 orderlist-main">
  <div *ngIf="!isSuperAdmin" class="row">
    <app-transaction-summary-shared
      [summary]="summary"
      [transactions]="orders$"
      [transactionType]="2"
    ></app-transaction-summary-shared>
  </div>
  <div class="eatos-card">
    <div class="card-body">
      <div  class="d-sm-flex justify-content-between row-status sales-main">
        <div class="d-flex gap-4">
          <div class="d-flex flex-wrap sales-data w-sm-auto w-100">
            <div class="col-auto col-report">
              <div class="input-group cusdaterangepicker">
                <div
                  class="net-sale-daterange-picker form-group text-start form-control border-0 p-0"
                  style="border-radius: 2.6px"
                >
                  <div
                    class="datepickerwrap form-control"
                    daterangepicker
                    [options]="options"
                    (selected)="selectedDate($event)"
                    style="border-radius: 2.6px"
                    (click)="setDateTexts()"
                  >
                    <span class="date-text">
                      <span class="display-date f-12">{{
                        startDateDisplayFormatted | translate | async
                      }}</span>
                      -
                      <span class="display-date f-12">{{
                        endDateDisplayFormatted | translate | async
                      }}</span>
                    </span>
                    <img
                      src="../../../../assets/images/dashboard-images/bx-calendar.svg"
                      class="picker-icon"
                      class="ms-2"
                    />
                  </div>
                </div>
                <div class="filter-btn" (click)="OpenFilterCanva(content1)">
                  <button>
                    <img src="/assets/images/filter.svg" alt="filter" />
                  </button>
                </div>
              </div>
              <div class="">
                <ng-template #content1 let-offcanvas>
                  <div class="Filter-Canvas-open">
                    <!-- filter -->
                    <div class="action-data" *ngIf="OpenDetails === 'mainMenu'">
                      <h2 class="mb-0">{{ "Filters" | translate | async }}</h2>
                      <button
                        type="button"
                        class="btn-close"
                        aria-label="Close"
                        (click)="offcanvas.dismiss('Cross click')"
                      ></button>
                    </div>
                    <!-- End Filter -->
                    <div
                      class="back-time"
                      *ngIf="OpenDetails === 'StartEndDate'"
                      (click)="OpenDetails = 'mainMenu'"
                    >
                      <i class="fa-solid fa-arrow-left f-20"></i>
                      <p class="f-14 fw-600 mb-0" *ngIf="Ruler">
                        {{ "Day Part" | translate | async }}
                      </p>
                      <p class="f-14 fw-600 mb-0" *ngIf="!Ruler">
                        {{ startTimeFormatted | translate | async }} - {{ endTimeFormatted | translate | async }}
                      </p>
                    </div>
                    <div
                      class="back-time"
                      *ngIf="OpenDetails === 'SelectOrderType'"
                      (click)="OpenDetails = 'mainMenu'"
                    >
                      <i class="fa-solid fa-arrow-left f-20"></i>
                      <p class="f-14 fw-600 mb-0">{{ "Order Type" | translate | async }}</p>
                    </div>
                    <div class="col-auto col-report">
                      <div class="input-group w-auto">
                        <select
                          class="form-select custom-select f-12 fw-500"
                          aria-label="Select Store"
                          [(ngModel)]="selectedStore"
                          (change)="onStoreChange($event)"
                        >
                          <option value="">{{ 'Select Store' | translate | async }}</option>
                          <option *ngFor="let store of stores" [value]="store.id">{{ store.name }}</option>
                        </select>
                      </div>
                    </div>

                    <!-- select Employee -->
                    <div
                      class="back-time"
                      *ngIf="OpenDetails === 'SelectEmployee'"
                      (click)="OpenDetails = 'mainMenu'"
                    >
                      <i class="fa-solid fa-arrow-left f-20"></i>
                      <p class="f-14 fw-600 mb-0">{{ "Employees" | translate | async }}</p>
                    </div>
                    <!-- End Employee -->
                    <div
                      class="back-time"
                      *ngIf="OpenDetails === 'SelectOrderstatus'"
                      (click)="OpenDetails = 'mainMenu'"
                    >
                      <i class="fa-solid fa-arrow-left f-20"></i>
                      <p class="f-14 fw-600 mb-0">{{ "Order Status" | translate | async }}</p>
                    </div>

                    <!-- <div
                      class="back-time"
                      *ngIf="OpenDetails === 'ExportDetails'"
                      (click)="OpenDetails = 'mainMenu'"
                    >
                      <i class="fa-solid fa-arrow-left f-20"></i>
                      <p class="f-14 fw-600 mb-0">{{ "Export" | translate | async }}</p>
                    </div> -->
                    <div class="action-list">
                      <div class="d-inline-block in-bott">
                        <button
                          (click)="OpenDetails = 'StartEndDate'"
                          type="button"
                          class="btn f-14 fw-500 sec-btn mb-14"
                          id="dropdownBasic1"
                          *ngIf="OpenDetails === 'mainMenu'"
                        >
                          <span *ngIf="Ruler"> {{ "Day Part" | translate | async }}</span>
                          <span *ngIf="!Ruler">
                            {{ startTimeFormatted | translate | async }} - {{ endTimeFormatted | translate | async }}
                          </span>
                          <i class="fa-solid fa-chevron-right"></i>
                        </button>
                      </div>
                      <div class="" *ngIf="OpenDetails === 'StartEndDate'">
                        <div class="d-flex justify-content-between align-items-center f-12 fw-500">
                          <div class="">
                            <p class="mb-0">{{ "Start" | translate | async }}</p>
                          </div>
                          <div class="p-2 position-relative">
                            <ng-select
                              class="form-select f-12 fw-500 custom-select"
                              id="Select1"
                              [(ngModel)]="startTime"
                              (click)="startDateErr = !startDateErr"
                              (blur)="startDateErr = false"
                            >
                              <ng-option
                                [value]="startDate.id"
                                *ngFor="let startDate of dateTimeArray"
                              >
                                {{ startDate.text }}
                              </ng-option>
                            </ng-select>
                            <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="icon icon-tabler icon-tabler-chevron-down ms-3 discount-select-arrow"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            stroke-width="2"
                            stroke="currentColor"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            [class.rotate-up]="startDateErr"
                          >
                            <path
                              stroke="none"
                              d="M0 0h24v24H0z"
                              fill="none"
                            ></path>
                            <polyline points="6 9 12 15 18 9"></polyline>
                          </svg>
                          </div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center f-12 fw-500">
                          <div class="">
                            <p  class="mb-0">{{ "End" | translate | async }}</p>
                          </div>
                          <div class="p-2 position-relative">
                            <ng-select
                              id="Select2"
                              [(ngModel)]="endTime"
                              class="form-select f-12 fw-500 custom-select"
                              (click)="EndDateErr = !EndDateErr"
                           (blur)="EndDateErr = false"
                            >
                              <ng-option
                                [value]="endDate.id"
                                *ngFor="let endDate of dateTimeArray"
                              >
                                {{ endDate.text }}
                              </ng-option>
                            </ng-select>
                            <svg
                            xmlns="http://www.w3.org/2000/svg"
                            class="icon icon-tabler icon-tabler-chevron-down ms-3 discount-select-arrow "
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            stroke-width="2"
                            stroke="currentColor"
                            fill="none"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            [class.rotate-up]="EndDateErr"
                          >
                            <path
                              stroke="none"
                              d="M0 0h24v24H0z"
                              fill="none"
                            ></path>
                            <polyline points="6 9 12 15 18 9"></polyline>
                          </svg>
                          </div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center f-12 fw-500">
                          <div class="mt-1">
                            <input
                              class="form-check-input custom-form-radio me-2"
                              type="radio"
                              id="Second1"
                              value="Same Day"
                              [(ngModel)]="ClosingDay"
                              [checked]="sameDayIsChecked()"
                              (ngModelChange)="selectClosingDay($event)"
                            />
                            <label class="form-check-label" for="Second1">
                              {{ "Same Day" | translate | async }}
                            </label>
                          </div>
                        </div>
                        <div class="d-flex justify-content-between align-items-center f-12 fw-500">
                          <div class="mt-1">
                            <input
                              class="form-check-input custom-form-radio me-2"
                              type="radio"
                              id="Second2"
                              value="Next Day"
                              [(ngModel)]="ClosingDay"
                              [checked]="nextDayIsChecked()"
                              (ngModelChange)="selectClosingDay($event)"
                            />
                            <label class="form-check-label" for="Second2">
                              {{ "Next Day" | translate | async }}
                              <i
                                class="f-10 fas fa-info-circle vertical-align-super"
                                [ngbPopover]="'Generate your reports for same day or next day (allowing custom 24 hour range) based on the restaurants daily hours of operation' | translate | async"
                                triggers="mouseenter:mouseleave"
                                [popoverTitle]="'Next Day' | translate | async"
                                data-bs-placement="right"
                              ></i>
                            </label>
                          </div>
                        </div>
                        <div class="f-12 fw-500">
                          <div class="mt-2">
                            <button
                              class="btn btn-dark btn-block w-100 pt-1 pb-1 f-14"
                              (click)="timeFilter(); myDrop.close()"
                              [disabled]="
                                (ClosingDay == 'Next Day' &&
                                  startDateDisplay == endDateDisplay) ||
                                (ClosingDay == 'Same Day' &&
                                  timeDiasbleValidation())
                              "
                            >
                              {{ "Apply" | translate | async }}
                            </button>
                          </div>
                        </div>
                        <!-- <div>
                          <div class="form-check" (click)="clickDayAllOption()">
                            <input
                              class="form-check-input"
                              checked
                              type="radio"
                              name="daygroup"
                              id="allday"
                            />
                            <label class="form-check-label" for="allday">
                              All Day
                            </label>
                          </div>
                          <div class="dropdown-divider"></div>
                          <div
                            class="form-check mb-2"
                            (click)="clickCustomizeOption()"
                          >
                            <input
                              class="form-check-input"
                              type="radio"
                              name="daygroup"
                              id="custom"
                            />
                            <label class="form-check-label" for="custom">
                              Custom
                            </label>
                          </div>
                          <div
                            class="form-group d-flex align-items-center start-time"
                          >
                            <label class="text-end">Start</label>
                            <select
                              class="form-select mb-2"
                              style="margin-left: 8px"
                              aria-label="Default select example"
                              [disabled]="!Ruler"
                              [(ngModel)]="startTime"
                              (change)="changeStartTimeOrder($event)"
                            >
                              <option
                                *ngFor="let startTime of transactionTimeArray"
                                value="{{ startTime.id }}"
                              >
                                {{ startTime.text }}
                              </option>
                            </select>
                          </div>
                          <div
                            class="form-group d-flex align-items-center end-time"
                          >
                            <label class="text-end">End</label>
                            <select
                              class="form-select mb-2"
                              style="margin-left: 15px"
                              aria-label="Default select example"
                              [disabled]="!Ruler"
                              [(ngModel)]="endTime"
                              (change)="changeEndTimeOrder($event)"
                            >
                              <option
                                *ngFor="let endTime of transactionTimeArray"
                                value="{{ endTime.id }}"
                              >
                                {{ endTime.text }}
                              </option>
                            </select>
                          </div>
                        </div> -->
                      </div>
                      <div
                        *ngIf="OpenDetails === 'mainMenu'"
                        class="d-inline-block mb-14 in-bott"
                        (click)="OpenDetails = 'SelectOrderType'"
                      >
                        <button
                          type="button"
                          class="btn f-14 fw-500 sec-btn"
                          id="dropdownBasic1"
                        >
                          {{ "Order Type" | translate | async }}
                          <i class="fa-solid fa-chevron-right"></i>
                        </button>
                      </div>
                      <div
                        *ngIf="OpenDetails === 'mainMenu'"
                        class="d-inline-block in-bott mb-14"
                        (click)="OpenDetails = 'SelectEmployee'"
                      >
                        <button
                          type="button"
                          class="btn f-14 fw-500 sec-btn"
                          id="dropdownBasic1"
                        >
                          {{ "Employees" | translate | async }}
                          <i class="fa-solid fa-chevron-right"></i>
                        </button>
                      </div>
                      <div
                        *ngIf="OpenDetails === 'mainMenu'"
                        class="d-inline-block mb-14 in-bott"
                        (click)="OpenDetails = 'SelectOrderstatus'"
                      >
                        <button
                          type="button"
                          class="btn f-14 fw-500 sec-btn"
                          id="dropdownBasic1"
                        >
                          {{ "Order Status" | translate | async }}
                          <i class="fa-solid fa-chevron-right"></i>
                        </button>
                      </div>
                      <div
                        class="search-main mb-20"
                        *ngIf="OpenDetails === 'mainMenu'"
                      >
                        <input
                          id="search"
                          type="search"
                          class="search-box"
                          [placeholder]="'Filter By Order Number' | translate | async"
                          [(ngModel)]="orderNumber"
                          onkeypress="return event.charCode >= 48 && event.charCode <= 57"
                          (ngModelChange)="filterByOrderId($event)"
                        />
                        <i class="fa-solid fa-magnifying-glass search-icon"></i>
                      </div>
                      <!-- <div
                        *ngIf="OpenDetails === 'mainMenu'"
                        class="d-inline-block in-bott"
                      >
                        <button
                          (click)="OpenDetails = 'ExportDetails'"
                          type="button"
                          class="btn f-14 fw-500 sec-btn"
                          id="dropdownBasic1"
                        >
                          {{ "Export" | translate | async }}
                          <i class="fa-solid fa-chevron-right"></i>
                        </button>
                      </div> -->

                      <!-- select Employee -->
                      <div *ngIf="OpenDetails === 'SelectEmployee'">
                        <div
                          class="d-flex gap-14 align-items-center detalis mb-20"
                        >
                          <p class="m-0 f-14 fw-500 text-gry">{{ "All Employees" | translate | async }}</p>
                        </div>
                        <div class="" *ngFor="let employee of activeEmployees$">
                          <div
                            class="detalis mb-20 d-flex gap-14 align-items-center"
                            (click)="NewchangeEmployee(employee.id)"
                          >
                            <span class="f-14 fw-500">{{ employee.name | translate | async }}</span>
                          </div>
                        </div>
                      </div>
                      <!-- End Employee -->
                      <div *ngIf="OpenDetails === 'SelectOrderType'">
                        <div class="" *ngFor="let order of orderTypes">
                          <div
                            class="detalis mb-20 d-flex gap-14 align-items-center"
                            (click)="NewchangeTypeStatus(order.id)"
                          >
                            <span class="f-14 fw-500">{{ order.text | translate | async }}</span>
                          </div>
                        </div>
                      </div>

                      <div *ngIf="OpenDetails === 'SelectOrderstatus'">
                        <div class="" *ngFor="let order of NeworderStaus">
                          <div
                            class="detalis mb-20 d-flex gap-14 align-items-center"
                            (click)="NewchangeOrderStatus(order.value)"
                          >
                            <span class="f-14 fw-500">{{ order.name | translate | async }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Export -->
                    <div>
                      <div class="" *ngIf="OpenDetails === 'ExportDetails'">
                        <div
                          class="d-flex align-items-center gap-12 p-btn"
                          (click)="exportReport('pdf')"
                        >
                          <img src="/assets/images/pdf-expo.svg" alt="expo" />
                          <p class="f-14 fw-500 black mb-0">{{ "Export PDF" | translate | async }}</p>
                        </div>
                        <div
                          class="d-flex align-items-center gap-12 p-btn"
                          (click)="exportReport('csv')"
                        ><i class="fas fa-file-excel excel-main-icon"></i>
                          <!-- <img src="/assets/images/csv-expo.svg" alt="expo" /> -->
                          <p class="f-14 fw-500 black mb-0">{{ "Export EXCEL" | translate | async }}</p>
                        </div>
                      </div>
                    </div>.
                  </div>
                </ng-template>
              </div>
            </div>
            <!-- <div class="col-auto">
              <div class="input-group mb-3 w-auto">
                <div accessControl module="Order" access=3 ngbDropdown #myDrop="ngbDropdown" display="dynamic"
                  container="body" class="d-inline-block">
                  <button accessControl module="Order" access=3 class="btn f-12 fw-500 sec-btn" id="dropdownBasic2"
                    ngbDropdownToggle>
                    <span *ngIf="Ruler == false">Day Part</span>
                    <span *ngIf="Ruler != false">{{ startTimeFormatted }} - {{ endTimeFormatted }}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-chevron-down ms-5"
                      width="16" height="16" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                      stroke-linecap="round" stroke-linejoin="round">
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </button>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic2" class="p-2">
                    <div class="form-check" (click)="clickDayAllOption()">
                      <input class="form-check-input" checked type="radio" name="daygroup" id="allday" />
                      <label class="form-check-label" for="allday"> All Day </label>
                    </div>
                    <div class="dropdown-divider"></div>
                    <div class="form-check mb-2" (click)="clickCustomizeOption()">
                      <input class="form-check-input" type="radio" name="daygroup" id="custom" />
                      <label class="form-check-label" for="custom"> Custom </label>
                    </div>
                    <div class="form-group d-flex align-items-center start-time">
                      <label class="text-end">Start</label>
                      <select class="form-select mb-2" style="margin-left: 8px;" aria-label="Default select example"
                        [disabled]="!Ruler" [(ngModel)]="startTime" (change)="changeStartTimeOrder($event)">
                        <option *ngFor="let startTime of dateTimearray" value="{{ startTime.id }}">
                          {{ startTime.text }}
                        </option>
                      </select>
                    </div>
                    <div class="form-group d-flex align-items-center end-time">
                      <label class="text-end">End</label>
                      <select class="form-select mb-2" style="margin-left: 15px;" aria-label="Default select example"
                        [disabled]="!Ruler" [(ngModel)]="endTime" (change)="changeEndTimeOrder($event)">
                        <option *ngFor="let endTime of dateTimearray" value="{{ endTime.id }}">
                          {{ endTime.text }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- #################################################### -->
            <div class="col-auto col-report mob-report">
              <!-- NEW FILTER -->
              <div class="input-group in-bott">
                <div
                  ngbDropdown
                  #myDrop="ngbDropdown"
                  class="d-inline-block mb-3 in-bott"
                >
                  <button
                    type="button"
                    class="btn f-12 fw-500 sec-btn"
                    id="dropdownBasic1"
                    ngbDropdownToggle
                    (click)="stardateformate = !stardateformate"
                       (blur)="stardateformate = false"
                  >
                    {{ startTimeFormatted | translate | async }} - {{ endTimeFormatted | translate | async }}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon-tabler icon-tabler-chevron-down"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      [class.rotate-up]="myDrop.isOpen()"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </button>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <div class="d-flex justify-content-between f-12 fw-500">
                      <div class="me-2 ms-2 mt-3">
                        <p>{{ "Start" | translate | async }}</p>
                      </div>
                      <div class="p-0 position-relative">
                        <ng-select
                          class="form-select f-12 fw-500  custom-dropdown "
                          id="Select1"
                          [(ngModel)]="startTime"
                          style="width: 100px !important;"
                          >
                          <!-- (click)="startDateErr = !startDateErr"
                          (blur)="startDateErr = false" -->
                          <ng-option
                            [value]="startDate.id"
                            *ngFor="let startDate of dateTimeArray"
                          >
                            {{ startDate.text }}
                          </ng-option>
                        </ng-select>
                        <!-- <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-chevron-down ms-3 discount-select-arrow"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        [class.rotate-up]="startDateErr"
                      >
                        <path
                          stroke="none"
                          d="M0 0h24v24H0z"
                          fill="none"
                        ></path>
                        <polyline points="6 9 12 15 18 9"></polyline>
                      </svg> -->
                      </div>
                    </div>
                    <div class="d-flex justify-content-between f-12 fw-500">
                      <div class="me-2 ms-2 mt-3">
                        <p>{{ "End" | translate | async }}</p>
                      </div>
                      <div class="p-0 position-relative">
                        <ng-select
                          id="Select2"
                          [(ngModel)]="endTime"
                          class="form-select f-12 fw-500 custom-dropdown "
                          style="width: 100px !important;"
                        >
                          <ng-option
                            [value]="endDate.id"
                            *ngFor="let endDate of dateTimeArray"
                          >
                            {{ endDate.text }}
                          </ng-option>
                        </ng-select>
                        <!-- <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-chevron-down ms-3 discount-select-arrow "
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        [class.rotate-up]="EndDateErr"
                      >
                        <path
                          stroke="none"
                          d="M0 0h24v24H0z"
                          fill="none"
                        ></path>
                        <polyline points="6 9 12 15 18 9"></polyline>
                      </svg> -->
                      </div>
                    </div>
                    <div class="d-flex justify-content-between f-12 fw-500">
                      <div class="me-2 ms-2 mt-1">
                        <input
                          class="form-check-input custom-form-radio me-2"
                          type="radio"
                          id="Second1"
                          value="Same Day"
                          [(ngModel)]="ClosingDay"
                          [checked]="sameDayIsChecked()"
                          (ngModelChange)="selectClosingDay($event)"
                        />
                        <label class="form-check-label" for="Second1">
                          {{ "Same Day" | translate | async }}
                        </label>
                      </div>
                    </div>
                    <div class="d-flex justify-content-between f-12 fw-500">
                      <div class="me-2 ms-2 mt-1">
                        <input
                          class="form-check-input custom-form-radio me-2"
                          type="radio"
                          id="Second2"
                          name="closingDay"
                          value="Next Day"
                          [(ngModel)]="ClosingDay"
                          [checked]="nextDayIsChecked()"
                          (ngModelChange)="selectClosingDay($event)"
                        />
                        <label class="form-check-label" for="Second2">
                          {{ "Next Day" | translate | async }}
                          <i
                            class="f-10 fas fa-info-circle vertical-align-super"
                            [ngbPopover]="'Generate your reports for same day or next day (allowing custom 24 hour range) based on the restaurants daily hours of operation' | translate | async"
                            triggers="mouseenter:mouseleave"
                            [popoverTitle]="'Next Day' | translate | async"
                            data-bs-placement="right"
                          ></i>
                        </label>
                      </div>
                    </div>
                    <div class="f-12 fw-500">
                      <div class="me-2 ms-2 mt-1">
                        <button
                          class="btn btn-dark btn-block btn-sm w-100 d-flex justify-content-center"
                          (click)="timeFilter(); myDrop.close()"
                          [disabled]="
                            (ClosingDay == 'Next Day' &&
                              startDateDisplay == endDateDisplay) ||
                            (ClosingDay == 'Same Day' &&
                              timeDiasbleValidation())
                          "
                        >
                          {{ "Apply" | translate | async }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- OLD FILTER -->
              <!-- <div class="input-group in-bott">
                <div
                  accessControl
                  module="SalesTransaction"
                  access="3"
                  ngbDropdown
                  #myDrop="ngbDropdown"
                  display="dynamic"
                  container="body"
                  class="d-inline-block w-100"
                >
                  <button
                    accessControl
                    module="SalesTransaction"
                    access="3"
                    type="button"
                    class="btn f-12 fw-500 sec-btn"
                    style="z-index: 0 !important"
                    id="dropdownBasic2"
                    ngbDropdownToggle
                  >
                    <span *ngIf="Ruler == false">Day Part</span>
                    <span *ngIf="Ruler != false"
                      >{{ startTimeFormatted }} - {{ endTimeFormatted }}</span
                    >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon-tabler icon-tabler-chevron-down ms-5"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      stroke-width="2"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                      <polyline points="6 9 12 15 18 9"></polyline>
                    </svg>
                  </button>
                  <div
                    ngbDropdownMenu
                    aria-labelledby="dropdownBasic2"
                    class="p-2"
                  >
                    <div class="form-check" (click)="clickDayAllOption()">
                      <input
                        class="form-check-input"
                        checked
                        type="radio"
                        name="daygroup"
                        id="allday"
                      />
                      <label class="form-check-label" for="allday">
                        All Day
                      </label>
                    </div>
                    <div class="dropdown-divider"></div>
                    <div
                      class="form-check mb-2"
                      (click)="clickCustomizeOption()"
                    >
                      <input
                        class="form-check-input"
                        type="radio"
                        name="daygroup"
                        id="custom"
                      />
                      <label class="form-check-label" for="custom">
                        Custom
                      </label>
                    </div>
                    <div
                      class="form-group d-flex align-items-center start-time"
                    >
                      <label class="text-end">Start</label>
                      <select
                        class="form-select mb-2"
                        style="margin-left: 8px"
                        aria-label="Default select example"
                        [disabled]="!Ruler"
                        [(ngModel)]="startTime"
                        (change)="changeStartTimeOrder($event)"
                      >
                        <option
                          *ngFor="let startTime of transactionTimeArray"
                          value="{{ startTime.id }}"
                        >
                          {{ startTime.text }}
                        </option>
                      </select>
                    </div>
                    <div class="form-group d-flex align-items-center end-time">
                      <label class="text-end">End</label>
                      <select
                        class="form-select mb-2"
                        style="margin-left: 15px"
                        aria-label="Default select example"
                        [disabled]="!Ruler"
                        [(ngModel)]="endTime"
                        (change)="changeEndTimeOrder($event)"
                      >
                        <option
                          *ngFor="let endTime of transactionTimeArray"
                          value="{{ endTime.id }}"
                        >
                          {{ endTime.text }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          '  <!-- <div class="col-auto col-report">'
              <div class="input-group w-auto">
                <select
                  class="form-select custom-select f-12 fw-500"
                  aria-label="Select Store"
                  [(ngModel)]="selectedStore"
                  (change)="onStoreChange($event)"
                >
                  <option value="">{{ 'Select Store' | translate | async }}</option>
                  <option *ngFor="let store of stores" [value]="store.storeId">{{ store.storeName }}</option>
                </select>
              </div>
            </div> -->
            <div class="col-auto col-report d-inline-block mob-report">
              <div class="input-group">
                <select
                  class="form-select custom-select custom-select-details f-12 fw-500"
                  aria-label="Default select example"
                  [(ngModel)]="selectedStore"
                  (change)="onStoreChange($event)"
                  >
                  <!-- (click)="OrderTypeErr = !OrderTypeErr"
                  (blur)="OrderTypeErr = false" -->
                  <!-- (click)="OrderTypeTorggle()" -->

                  <option selected value="">{{ "Select Store" | translate | async }}</option>
                  <option
                    *ngFor="let store of stores"
                    value="{{ store.storeId }}"
                  >
                    {{ store.storeName  | translate | async }}
                  </option>
                </select>
                <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-chevron-down ms-3"
                [ngClass]="stardateformate ? 'SetZindex' : 'order-list-arrow'"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                [class.rotate-up]="OrderTypeErr"
              >
                <path
                  stroke="none"
                  d="M0 0h24v24H0z"
                  fill="none"
                ></path>
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
              </div>
            </div>

            <div class="col-auto col-report d-inline-block mob-report">
              <div class="input-group">
                <select
                  class="form-select custom-select custom-select-details f-12 fw-500"
                  aria-label="Default select example"
                  [(ngModel)]="orderTypeSelected"
                  (change)="changeTypeStatus($event)"
                  (click)="OrderTypeErr = !OrderTypeErr"

                  (blur)="OrderTypeErr = false"
                >
                <!-- (click)="OrderTypeTorggle()" -->

                  <option selected value="">{{ "Order Type" | translate | async }}</option>
                  <option
                    *ngFor="let option of orderTypes"
                    value="{{ option.id }}"
                  >
                    {{ option.text | translate | async }}
                  </option>
                </select>
                <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-chevron-down ms-3"
                [ngClass]="stardateformate ? 'SetZindex' : 'order-list-arrow'"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                [class.rotate-up]="OrderTypeErr"
              >
                <path
                  stroke="none"
                  d="M0 0h24v24H0z"
                  fill="none"
                ></path>
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
              </div>
            </div>
            <div class="col-auto col-report d-inline-block mob-report">
              <div class="input-group">
                <select
                  class="form-select custom-select custom-select-details f-12 fw-500 "
                  aria-label="Default select example"
                  (change)="changeEmployee($event)"
                  [(ngModel)]="employeeSelected"
                  (click)="EmployeeErr = !EmployeeErr"
                  (blur)="EmployeeErr = false"
                  >
                  <!-- (click)="EmployeeToggle()" -->
                  <option selected value="">{{ "All Employees" | translate | async }}</option>
                  <option
                    *ngFor="let emp of activeEmployees$"
                    value="{{ emp.id }}"
                  >
                    {{ emp.name | translate | async }}
                  </option>
                </select>
                <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-chevron-down ms-3"
                [ngClass]="stardateformate ? 'SetZindex' : 'order-list-arrow'"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                [class.rotate-up]="EmployeeErr"
              >
                <path
                  stroke="none"
                  d="M0 0h24v24H0z"
                  fill="none"
                ></path>
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
              </div>
            </div>
            <div class="col-auto col-report d-inline-block mob-report">
              <div class="input-group">
                <select
                  class="form-select custom-select custom-select-details f-12 fw-500"
                  aria-label="Default select example"
                  [(ngModel)]="orderStatusSelected"
                  (change)="changeOrderStatus($event)"
                  (click)="IsorderStatusError = !IsorderStatusError"
                  (blur)="IsorderStatusError = false"
                  >
                  <!-- (click)="toggleDropdown1()" -->
                  <option selected value="">{{ "Order Status" | translate | async }}</option>
                  <option value="1">{{ "Ordering" | translate | async }}</option>
                  <option value="2">{{ "Payment in Progress" | translate | async }}</option>
                  <option value="3">{{ "Paid" | translate | async }}</option>
                  <option value="4">{{ "Completed" | translate | async }}</option>
                  <option value="5">{{ "Partially Refunded" | translate | async }}</option>
                  <option value="6">{{ "Refunded" | translate | async }}</option>
                  <option value="7">{{ "Cancelled" | translate | async }}</option>
                  <option value="8">{{ "Custom Refunded" | translate | async }}</option>
                  <option value="9">{{ "Void" | translate | async }}</option>
                </select>
                <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-chevron-down ms-3"
                [ngClass]="stardateformate ? 'SetZindex' : 'order-list-arrow'"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
                [class.rotate-up]="IsorderStatusError"
              >
                <path
                  stroke="none"
                  d="M0 0h24v24H0z"
                  fill="none"
                ></path>
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-sm-end gap-4 export-data mob-report">
          <div class="searchinput spermiss">
            <span (click)="searchInput.focus()">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="icon icon-tabler icon-tabler-search"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                stroke-width="2"
                stroke="currentColor"
                fill="none"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <circle cx="10" cy="10" r="7"></circle>
                <line x1="21" y1="21" x2="15" y2="15"></line>
              </svg>
            </span>
            <input
              #searchInput
              type="search"
              class="form-control transaction-input br-round f-12"
              [placeholder]="'Filter By Order Number' | translate | async"
              [(ngModel)]="orderNumber"
              onkeypress="return event.charCode >= 48 && event.charCode <= 57"
              (ngModelChange)="filterByOrderId($event)"
              style="width: 205px"
            />
          </div>
          <!-- <div class="col-auto">
            <div class="input-group mb-3 w-auto">
              <div accessControl module="Order" access=3 ngbDropdown #myDrop="ngbDropdown" display="dynamic" container="body"
                class="d-inline-block">
                <button accessControl module="Order" access=3 [disabled]="orders$.length === 0"
                  class="btn f-12 fw-500 sec-btn" id="dropdownBasic3" ngbDropdownToggle>
                  Export
                  <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-chevron-down ms-3"
                    width="16" height="16" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic3" class="p-2">
                  <a href="javascript: void (0)" (click)="exportReport('pdf')" class="text-dark">
                    <i class="fas fa-file-pdf"></i>
                    <span>&nbsp;&nbsp;Export PDF</span>
                  </a>
                  <div class="dropdown-divider"></div>
                  <a href="javascript: void (0)" (click)="exportReport('excel')" class="text-dark">
                    <i class="fas fa-file-csv"></i>
                    <span>&nbsp;&nbsp;Export Excel</span>
                  </a>
                </div>
              </div>
            </div>
          </div> -->
          <div class="col-auto">
            <div class="input-group w-auto">
              <div
                accessControl
                module="SalesTransaction"
                access="3"
                ngbDropdown
                display="dynamic"
                container="body"
                class="d-inline-block"
              >
                <button
                  accessControl
                  module="SalesTransaction"
                  (click)="toggleDropdown()"
                  access="3"
                  [disabled]="orders$.length === 0"
                  class="btn f-12 fw-500 sec-btn"
                  style="z-index: 0 !important"
                  id="dropdownBasic3"
                  ngbDropdownToggle
                  (blur)="isDropdownOpen = false"
                  [ngStyle]="{
                    'pointer-events': orders$.length === 0 ? 'none' : 'auto'
                  }"
                >
                  <span>{{ "Export" | translate | async }}</span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-chevron-down ms-3"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    stroke-width="2"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    [class.rotate-up]="isDropdownOpen"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <polyline points="6 9 12 15 18 9"></polyline>
                  </svg>
                </button>
                <div
                  ngbDropdownMenu
                  aria-labelledby="dropdownBasic3"
                  class="p-2"
                >
                  <a
                    ngbDropdownItem
                    href="javascript: void (0)"
                    (click)="exportReport('pdf')"
                    class="text-dark"
                    [ngStyle]="{
                      'pointer-events': orders$.length === 0 ? 'none' : 'auto'
                    }"
                  >
                    <i class="fas fa-file-pdf"></i>
                    <span>&nbsp;&nbsp;{{ "Export PDF" | translate | async }}</span>
                  </a>
                  <div class="dropdown-divider"></div>
                  <a
                    ngbDropdownItem
                    href="javascript: void (0)"
                    (click)="exportReport('excel')"
                    class="text-dark"
                    [ngStyle]="{
                      'pointer-events': orders$.length === 0 ? 'none' : 'auto'
                    }"
                  >
                    <!-- <i class="fas fa-file-csv"></i> -->
                    <!-- <span>&nbsp;&nbsp;Export CSV</span> -->
                    <i class="fas fa-file-excel"></i>
                    <span>&nbsp;&nbsp;{{ "Export EXCEL" | translate | async }}</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="order-table mt-2 order-data" *ngIf="orders$.length !== 0">
        <div class="table-responsive-order" style="overflow: auto !important;">
          <table class="display dataTable no-footer table-make-responsive" style="width: 100%; margin: 0 auto; ">
             <thead style="position: sticky; top: 0; background: white" class="make-table-resp">
              <tr>
                <th class="text-center">{{ "Order No." | translate | async }}</th>
                <th class="text-center">{{ "Date Created" | translate | async }}</th>
                <th class="text-center">{{ "Time" | translate | async }}</th>
                <th class="text-center">{{ "Employee ID" | translate | async }}</th>
                <th class="text-center">{{ "Employee" | translate | async }}</th>
                <th class="text-center">{{ "Type" | translate | async }}</th>
                <th class="text-center">{{ "Order Source" | translate | async }}</th>
                <th class="text-center">{{ "Items Ordered" | translate | async }}</th>
                <th class="text-center">{{ "Status" | translate | async }}</th>
                <th class="text-center">{{ "Amount" | translate | async }}</th>
                </tr>
            </thead>
            <tbody class="fw-500">
              <ng-container
                *ngFor="
                  let Order of sortData(orders$)
                    | paginate
                      : {
                          itemsPerPage: itemsPP,
                          currentPage: p,
                          totalItems: metaData$.ordersTotal
                        };
                  let j = index
                "
              >
                <tr (click)="openModal(content, Order, j)" style="border-bottom: 1px solid #ccc;">
                  <ng-container
                    *ngIf="
                      (Order.parentId === null || Order.parentId === '') &&
                      Order.splitOrderList !== null &&
                      Order.splitOrderList.length !== 0
                    "
                  >
                    <td
                      class="text-center p-0"
                      *ngIf="
                        (Order.createdAt != 0 && !Order.product) ||
                        (Order.createdAt != 0 && Order.product)
                      "
                      (click)="showChildOrders(j, Order.orderId)"
                    >
                      <div class="position-relative">
                        <div
                          *ngIf="Order?.childOrders?.length > 0"
                          class="position-absolute"
                          style="left: 5px"
                        >
                          <span class="dropdown-icon">
                            <i
                              [ngClass]="
                                Order.enableChild
                                  ? 'mdi mdi-menu-up'
                                  : 'mdi mdi-menu-down'
                              "
                            ></i>
                          </span>
                        </div>
                      </div>
                      <!-- <div>
                        {{ Order.orderNumber }}
                      </div>
                      <div *ngIf="Order.offlineOrderNumber" style="font-weight: 400; font-size: 11px;">
                        [ {{ Order.offlineOrderNumber }} ]
                      </div> -->
                      <div *ngIf="Order.orderNumber">
                        {{ Order.orderNumber }}<span *ngIf="Order.offlineOrderNumber">-{{ Order.offlineOrderNumber }}</span>
                      </div>
                    </td>
                    <td
                      class="text-center"
                      *ngIf="
                        (Order.createdAt != 0 && !Order.product) ||
                        (Order.createdAt != 0 && Order.product)
                      "
                    >
                      <label
                        style="
                          position: relative;
                          cursor: pointer;
                          margin-bottom: 0;
                        "
                      >
                      </label>
                      <span>
                        {{ _convertDate(Order.orderId, Order.createdAt) | translate | async }}
                      </span>
                    </td>
                    <td class="text-center">
                      <span class="pb-2">
                        {{ _convertTime(Order.orderId, Order.createdAt) | translate | async }}
                      </span>
                    </td>
                    <td class="text-center">
                      <span class="pb-2"
                        >{{ Order.employeeCustomId ? "#" : ("Not Available" | translate | async)
                        }}{{ Order.employeeCustomId }}</span
                      >
                    </td>
                    <td class="text-center">
                      <span class="pb-2">{{ Order.employeeCompleteName }}</span>
                    </td>
                    <td class="text-center">
                      <span class="pb-2">{{
                        setDineIn(Order.orderTypeName) | translate | async
                      }}</span>
                    </td>
                    <td class="text-center">
                      <img
                        src="../../../assets/images/orders/{{
                          setSubTypeIcon(Order.orderType, Order.onlineOrderType)
                        }}"
                        style="width: 30px"
                      />
                    </td>
                    <td class="text-center">
                      {{ getJoinedProducts(Order.product) | translate | async}}
                      <span
                        *ngIf="getOtherJoinedProductCount(Order.product) === 1"
                        placement="bottom"
                        [ngbTooltip]="Order.product[4].productName"
                      >
                        +1
                      </span>
                      <span
                        *ngIf="getOtherJoinedProductCount(Order.product) > 1"
                        placement="bottom"
                        [ngbTooltip]="getOtherJoinedProducts(Order.product)"
                      >
                        +{{ getOtherJoinedProductCount(Order.product) }}
                      </span>
                    </td>
                    <td class="text-center">
                      <button
                        class="btn status-badge btn-sm"
                        [ngClass]="checkOrderStatus(Order.orderStatusName)"
                      >
                        {{
                          Order.orderSellStatus == 9
                            ? "Voided"
                            : Order.orderStatusName
                        }}
                      </button>
                      <!-- <button
                        *ngIf="Order.orderStatusName != 'No Data' && Order.orderSellStatus != 9"
                        class="btn status-badge btn-sm"
                        [ngClass]="checkOrderStatus(Order.orderStatusName)"
                      >
                        {{ Order.orderStatusName }}
                      </button>
                      <button
                        *ngIf="Order.orderStatusName == 'No Data' && Order.orderSellStatus != 9"
                        class="btn status-badge btn-sm"
                        [ngClass]="checkOrderStatus(Order.orderStatusName)"
                      >
                        {{ Order.orderStatusName }}
                      </button>
                      <button
                        *ngIf="Order.orderStatusName == 'No Data' && Order.orderSellStatus == 9"
                        class="btn status-badge btn-sm"
                        [ngClass]="checkOrderStatus(Order.orderSellStatus)"
                      >
                        Voided
                      </button> -->
                    </td>
                    <td class="text-center text-bold">
                      <!-- {{
                        Order.totalAmount
                          | currency : currency : "symbol" : "1.2-2"
                      }} -->
                      {{
                        (Order.orderSellStatus === 6 ? 0 : Order.totalAmount)
                          | currency : currency : "symbol" : "1.2-2"
                      }}
                    </td>
                  </ng-container>
                  <ng-container
                    *ngIf="
                      (Order.parentId === '' &&
                        Order.splitOrderList.length === 0) ||
                      (Order.parentId === null &&
                        Order.splitOrderList === null) ||
                      (Order.parentId === null &&
                        Order.splitOrderList.length === 0)
                    "
                  >
                    <td
                      class="text-center p-0"
                      *ngIf="
                        Order.createdAt != 0 &&
                        Order.product &&
                        Order.product.length >= 4
                      "
                    >
                      <div class="position-relative">
                        <div
                          *ngIf="Order?.childOrders?.length > 0"
                          class="position-absolute"
                          style="left: 5px"
                        >
                          <span
                            class="dropdown-icon"
                            (click)="
                              Order.toggle
                                ? ToggleToPositive(1, j)
                                : ToggleToPositive(2, j)
                            "
                          >
                            <i
                              [ngClass]="
                                Order.toggle
                                  ? 'mdi mdi-menu-up'
                                  : 'mdi mdi-menu-down'
                              "
                            ></i>
                          </span>
                        </div>
                        <!-- <div>
                          {{ Order.orderNumber }}
                        </div>
                        <div *ngIf="Order.offlineOrderNumber" style="font-weight: 400; font-size: 11px;">
                          [ {{ Order.offlineOrderNumber }} ]
                        </div> -->
                        <div *ngIf="Order.orderNumber">
                          {{ Order.orderNumber }}<span *ngIf="Order.offlineOrderNumber">-{{ Order.offlineOrderNumber }}</span>
                        </div>
                      </div>
                    </td>
                    <td
                      class="text-center"
                      *ngIf="
                        (Order.createdAt != 0 && !Order.product) ||
                        (Order.createdAt != 0 &&
                          Order.product &&
                          Order.product.length < 4)
                      "
                    >
                      <!-- <span>
                        {{ Order.orderNumber }}
                      </span> -->
                      <!-- <div>
                        {{ Order.orderNumber }}
                      </div>
                      <div *ngIf="Order.offlineOrderNumber" style="font-weight: 400; font-size: 11px;">
                        [ {{ Order.offlineOrderNumber }} ]
                      </div> -->
                      <div *ngIf="Order.orderNumber">
                        {{ Order.orderNumber }}<span *ngIf="Order.offlineOrderNumber">-{{ Order.offlineOrderNumber }}</span>
                      </div>
                    </td>
                    <td class="text-center">
                      <span>
                        {{ _convertDate(Order.orderId, Order.createdAt) | translate | async }}
                      </span>
                    </td>
                    <td class="text-center">
                      {{ _convertTime(Order.orderId, Order.createdAt) | translate | async }}
                    </td>
                    <td class="text-center">
                      {{ Order.employeeCustomId ? "#" : ("Not Available" | translate | async)
                      }}{{ Order.employeeCustomId }}
                    </td>
                    <td class="text-center">
                      {{ Order.employeeCompleteName }}
                    </td>
                    <td class="text-center">
                      {{ setDineIn(Order.orderTypeName) | translate | async}}
                    </td>
                    <td class="text-center">
                      <img
                        src="../../../assets/images/orders/{{
                          setSubTypeIcon(Order.orderType, Order.onlineOrderType)
                        }}"
                        style="width: 30px"
                      />
                    </td>
                    <td class="text-center">
                     <div class="order-joined-table">
                      {{ getJoinedProducts(Order.product) | translate | async }}
                      <span
                        *ngIf="getOtherJoinedProductCount(Order.product) === 1"
                        placement="bottom"
                        [ngbTooltip]="Order.product[4].productName"
                      >
                        +1
                      </span>
                      <span
                        *ngIf="getOtherJoinedProductCount(Order.product) > 1"
                        placement="bottom"
                        [ngbTooltip]="getOtherJoinedProducts(Order.product)"
                      >
                        +{{ getOtherJoinedProductCount(Order.product) }}
                      </span>
                     </div>
                    </td>
                    <td class="text-center">
                      <button
                        *ngIf="Order.orderSellStatus !== 9"
                        class="btn status-badge btn-sm"
                        [ngClass]="checkOrderStatus(Order.orderStatusName)"
                      >
                        {{
                          (Order.orderSellStatus === 8
                            ? "Custom refund"
                            : Order.orderStatusName) | translate | async
                        }}
                      </button>
                      <button
                        *ngIf="Order.orderSellStatus === 9"
                        class="btn status-badge btn-sm"
                        [ngClass]="checkOrderStatus(Order.orderStatusName)"
                      >
                        {{
                          (Order.orderSellStatus === 9
                            ? "Voided"
                            : Order.orderStatusName) | translate | async
                        }}
                      </button>
                    </td>
                    <td class="text-center text-bold">
                      <!-- {{
                        Order.totalAmount
                          | currency : currency : "symbol" : "1.2-2"
                      }} -->
                      {{
                        (Order.orderSellStatus === 6 ? 0 : Order.totalAmount)
                          | currency : currency : "symbol" : "1.2-2"
                      }}
                    </td>
                  </ng-container>
                </tr>
                <ng-container *ngIf="Order.enableChild">
                  <tr class="collapssible-row">
                    <td class="text-center text-bold"></td>
                    <td class="text-center text-bold">{{ "Order No." | translate | async }}</td>
                    <td class="text-center text-bold">{{ "Time" | translate | async }}</td>
                    <td
                      class="text-center text-bold"
                      style="min-width: 120px; min-width: 120px"
                    >
                      {{ "Employee ID" | translate | async }}
                    </td>
                    <td class="text-center text-bold">{{ "Employee" | translate | async }}</td>
                    <td class="text-center text-bold">{{ "Type" | translate | async }}</td>
                    <th class="text-center">{{ "Order Source" | translate | async }}</th>
                    <td class="text-center text-bold">{{ "Items Ordered" | translate | async }}</td>
                    <td class="text-center text-bold">{{ "Status" | translate | async }}</td>
                    <td class="text-center text-bold">{{ "Amount" | translate | async }}</td>
                  </tr>
                  <ng-container
                    *ngFor="
                      let childOrderIds of findChidlOrders(
                        Order.splitOrderList
                      );
                      let iChild = index
                    "
                  >
                    <tr
                      class="pt-1"
                      (click)="openModal(content, childOrderIds, iChild)"
                    >
                      <td class="text-center"></td>
                      <td class="text-center">
                        <!-- <span
                          >{{ childOrderIds.orderNumber
                          }}{{ childOrderIds.orderNumberSuffix }}</span> -->
                          <!-- <div>
                            {{ childOrderIds.orderNumber
                            }}{{ childOrderIds.orderNumberSuffix }}
                          </div> -->
                          <!-- <div *ngIf="childOrderIds.offlineOrderNumber" style="font-weight: 400; font-size: 11px;">
                            [ {{ childOrderIds.offlineOrderNumber }} ]
                          </div> -->
                          <div *ngIf="childOrderIds.orderNumber">
                            {{ childOrderIds.orderNumber }}{{ childOrderIds.orderNumberSuffix }}<span *ngIf="childOrderIds.offlineOrderNumber">-{{ childOrderIds.offlineOrderNumber }}</span>
                          </div>
                      </td>
                      <td class="text-center">
                        <span>
                          {{
                            _convertTime(
                              childOrderIds.orderId,
                              childOrderIds.createdAt
                            ) | translate | async
                          }}
                        </span>
                      </td>
                      <td class="text-center">
                        <span class="pb-2"
                          >{{ childOrderIds.employeeCustomId ? "#" : ("Not Available" | translate | async)
                          }}{{ childOrderIds.employeeCustomId }}</span
                        >
                      </td>
                      <td class="text-center">
                        <span class="pb-2">{{
                          childOrderIds.employeeCompleteName
                        }}</span>
                      </td>
                      <td class="text-center">
                        <span>
                          {{ setDineIn(childOrderIds.orderTypeName) | translate | async }}</span
                        >
                      </td>
                      <td class="text-center">
                        <img
                          src="../../../assets/images/orders/{{
                            setSubTypeIcon(
                              childOrderIds.orderType,
                              childOrderIds.onlineOrderType
                            )
                          }}"
                          style="width: 30px"
                        />
                      </td>
                      <td>
                        <div class="text-center"  style="text-align: center;">
                          {{ getJoinedProducts(childOrderIds.product) | translate | async }}
                          <span *ngIf="getOtherJoinedProductCount(childOrderIds.product) === 1" placement="bottom"
                            [ngbTooltip]="childOrderIds.product[4].productName">
                            +1
                          </span>
                          <span *ngIf="getOtherJoinedProductCount(childOrderIds.product) > 1" placement="bottom"
                            [ngbTooltip]="getOtherJoinedProducts(childOrderIds.product) | translate | async">
                            +{{ getOtherJoinedProductCount(childOrderIds.product) }}
                          </span>
                        </div>
                      </td>
                      <td class="text-center">
                        <button
                          *ngIf="Order.orderSellStatus !== 9"
                          class="btn status-badge btn-sm"
                          [ngClass]="
                            checkOrderStatus(childOrderIds.orderStatusName)
                          "
                        >
                          {{
                            (Order.orderSellStatus === 8
                              ? "Custom refund"
                              : childOrderIds.orderStatusName) | translate | async
                          }}
                        </button>
                        <button
                          *ngIf="Order.orderSellStatus === 9"
                          class="btn status-badge btn-sm"
                          [ngClass]="checkOrderStatus(Order.orderStatusName)"
                        >
                          {{
                            (Order.orderSellStatus === 9
                              ? "Voided"
                              : Order.orderStatusName) | translate | async
                          }}
                        </button>
                      </td>
                      <td class="text-center">
                        <!-- <span>{{
                          childOrderIds.totalAmount
                            | currency : currency : "symbol" : "1.2-2"
                        }}</span> -->
                        <span>{{
                          (childOrderIds.orderSellStatus === 6 ? 0 : childOrderIds.totalAmount)
                            | currency : currency : "symbol" : "1.2-2"
                        }}</span>
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>
              </ng-container>
            </tbody>
          </table>
        </div>
        <!-- <div class="pagination-section" style="padding: 1.755em 0px">
          <div class="pagination-part">
            <app-paginate-select
              class=""
              [(parameter)]="itemsPP"
              (update)="onLimitSelected($event)"
            ></app-paginate-select>

            <div class="fw-500">
              {{ ("Showing " + (showItemCountPP + 1) + " to") | translate | async }}
              <span>{{ showItemCountPP + metaData$.itemsPerPage }}</span>{{ " of " | translate | async }}
              <span>{{ metaData$.ordersTotal }}</span> {{ "entries" | translate | async }}
            </div>

            <div class="d-flex">
              <pagination-controls
                class="pagination"
                (pageChange)="updatePage($event)"
              ></pagination-controls>
            </div>
          </div>
        </div> -->
        <div class="pagination-section">
          <div class="pagination-part">
        
            <div class="pagination-left">
              <app-paginate-select
                [(parameter)]="itemsPP"
                (update)="onLimitSelected($event)"
              ></app-paginate-select>
            </div>
        
            <div class="pagination-center">
              <div class="fw-500">
                {{ "Showing " + (showItemCountPP + 1) + " to" | translate | async }}
                <span>{{ showItemCountPP + metaData$.itemsPerPage }}</span>
                {{ " of " | translate | async }}
                <span>{{ metaData$.ordersTotal }}</span>
                {{ "entries" | translate | async }}
              </div>
            </div>
        
            <div class="pagination-right">
              <pagination-controls
                (pageChange)="updatePage($event)"
              ></pagination-controls>
            </div>
        
          </div>
        </div>
      </div>

      <div
        *ngIf="orders$.length === 0"
        class="empty-card d-flex align-items-center justify-content-center"
      >
        <div class="col-lg-4 col-12">
          <div class="d-flex justify-content-center mb-3">
            <img
              src="assets\images\sales-orders-icon.svg"
              class="card-img-top"
              style="width: 171px"
              alt="..."
            />
          </div>
          <div class="card-body text-center">
            <h5 class="card-title mb-4 text-xl">
              {{ "No Orders in This Time Frame" | translate | async }}
            </h5>
            <p class="card-text mb-4">
              {{ "No transactions took place during this time frame you selected. Please select a different range" | translate | async }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Standard Modal for product details -->

  <!-- ###################################################### -->
  <ng-template #content let-offcanvas>
    <div class="offcanvas-body">
      <div
        class="bill-details h-100 d-flex flex-column h-100"
        [ngClass]="!showRefundLoader && !showRefundSuccess ? '' : 'refund-main'"
      >
        <ng-container *ngIf="showOrderDetailPage">
          <div>
            <div class="d-flex justify-content-between mb-4 gap-4">
              <div
                class="f-40 fw-700 text-black paid_text text-uppercase"
                *ngIf="
                  orderReceipt.orderStatusName == 'Paid' ||
                  orderReceipt.orderStatusName == 'Completed'
                "
              >
                {{ orderReceipt.orderStatusName.toUpperCase() }}
                {{
                  orderReceipt !== undefined
                    ? (orderReceipt.totalAmount
                      | currency : currency : "symbol" : "1.2-2")
                    : ""
                }}
              </div>
              <div
                class="f-40 fw-700 paid_text"
                *ngIf="
                  orderReceipt.orderStatusName == 'Ordering' ||
                  orderReceipt.orderStatusName == 'Payment in progress'
                "
              >
                {{ orderReceipt.orderStatusName.toUpperCase() }}
                {{
                  orderReceipt !== undefined
                    ? (orderReceipt.totalAmount
                      | currency : currency : "symbol" : "1.2-2")
                    : ""
                }}
              </div>
              <div
                class="f-40 fw-700 paid_text"
                *ngIf="
                  orderReceipt.orderStatusName == 'Partially refunded' ||
                  orderReceipt.orderStatusName == 'Custom refunded' ||
                  orderReceipt.orderStatusName == 'Refunded' ||
                  orderReceipt.orderStatusName == 'Cancelled'
                "
              >
                {{ orderReceipt.orderStatusName.toUpperCase() }}
                {{
                  orderReceipt !== undefined
                    ? (orderReceipt.totalAmount
                      | currency : currency : "symbol" : "1.2-2")
                    : ""
                }}
              </div>
              <div
                class="f-40 fw-700 paid_text"
                *ngIf="orderReceipt.orderSellStatus === 8"
              >
                {{ "CUSTOM REFUND" | translate | async }}
                {{
                  orderReceipt !== undefined
                    ? (orderReceipt.totalAmount
                      | currency : currency : "symbol" : "1.2-2")
                    : ""
                }}
              </div>
              <div
                class="f-40 fw-700 paid_text"
                *ngIf="orderReceipt.orderSellStatus === 9"
              >
                {{ "Voided" | translate | async }}
                {{
                  orderReceipt !== undefined
                    ? (orderReceipt.totalAmount
                      | currency : currency : "symbol" : "1.2-2")
                    : ""
                }}
              </div>
              <div class="align-self-center">
                <button
                  type="button"
                  class="btn-close f-14 p-0 btn-details"
                  aria-label="Close"
                  (click)="
                    closeModal(content); offcanvasService.dismiss('Cross click')
                  "
                ></button>
              </div>
            </div>
            <div class="f-16 fw-500 receipt-num">
              <div class="d-flex justify-content-between mb-2">
                <div>
                  {{ "Order #" | translate | async }} :<b> {{ orderReceipt.orderNumber }}</b>
                </div>
                <div *ngIf="orderReceipt.createdAt == 0">---------</div>
                <div *ngIf="orderReceipt.createdAt != 0" class="text-uppercase">
                  {{
                    _convertDate(orderReceipt.orderId, orderReceipt.createdAt) | translate | async
                  }}
                </div>
              </div>
              <div class="d-flex justify-content-between mb-2">

                <!-- <div>
                  Check ID :<b> {{ orderReceipt.paymentNumber }}</b>
                </div> -->

                <ng-container *ngIf="orderReceipt.isOffline == 0">
                  <div>{{ "Check ID :" | translate | async }} <b>{{ orderReceipt.paymentNumber }}</b></div>
                 </ng-container>

                 <ng-container *ngIf="orderReceipt.isOffline != 0">
                  <div>{{ "Check ID :" | translate | async }} <b>{{ orderReceipt.offlineOrderNumber }}</b></div>
                 </ng-container>


                <div class="text-uppercase">{{ orderReceipt.time | translate | async }}</div>
              </div>
              <div
                class="mb-2"
                *ngIf="
                  orderReceipt.customerFirstName ||
                  orderReceipt.customerLastName
                "
              >
                {{ "Customer Name :" | translate | async }}
                <b
                  >{{ orderReceipt.customerFirstName }}
                  {{ orderReceipt.customerLastName }}</b
                >
              </div>
              <div
                class="mb-2"
                *ngIf="
                  !orderReceipt.customerFirstName && orderReceipt.orderName
                "
              >
                {{ "Customer Name :" | translate | async }}
                <b>{{ orderReceipt.orderName | translate | async }}</b>
              </div>
              <div
                class="mb-2"
                *ngIf="
                  !orderReceipt.customerFirstName && !orderReceipt.orderName
                "
              >
                {{ "Customer Name :" | translate | async }} <b>{{ "No Customer" | translate | async }}</b>
              </div>
              <div>
                <div
                  *ngIf="orderReceipt.vehicleDetails.vehicleNumber"
                  class="d-flex justify-content-between mb-2"
                >
                  <div>
                    {{ "Vehicle Number:" | translate | async }}<b>
                      {{ orderReceipt?.vehicleDetails?.vehicleNumber }}</b
                    >
                  </div>
                </div>
                <div
                  *ngIf="orderReceipt.vehicleDetails.vehicleType"
                  class="d-flex justify-content-between mb-2"
                >
                  <div>
                    {{ "Vehicle Type :" | translate | async }}<b>
                      {{ orderReceipt?.vehicleDetails?.vehicleType }}</b
                    >
                  </div>
                </div>
                <div
                  *ngIf="orderReceipt.vehicleDetails.vehicleColor"
                  class="d-flex justify-content-between mb-2"
                >
                  <div>
                    {{ "Vehicle Color:" | translate | async }}<b>
                      {{ orderReceipt?.vehicleDetails?.vehicleColor }}</b
                    >
                  </div>
                </div>
                <div
                  *ngIf="orderReceipt.vehicleDetails.vehicleBrand"
                  class="d-flex justify-content-between mb-2"
                >
                  <div>
                    {{ "Vehicle Brand :" | translate | async }}<b>
                      {{ orderReceipt?.vehicleDetails?.vehicleBrand }}</b
                    >
                  </div>
                </div>
              </div>
              <div class="mb-2" *ngIf="orderReceipt.serverId !== null">
                {{ "Employee Name :" | translate | async }}
                <b
                  >{{ orderReceipt?.serverId?.employeeFirstName | translate | async }}
                  {{ orderReceipt?.serverId?.employeeLastName | translate | async }}</b
                >
              </div>
              <div class="mb-2" *ngIf="orderReceipt.serverId === null">
                {{ "Employee Name :" | translate | async }} <b></b>
              </div>
            </div>
            <div class="overflow-auto">
              <table class="w-100 f-14 paid_slip mb-2">
                <thead>
                  <tr class="th-border f-14">
                    <th class="text-start">{{ "Qty" | translate | async }}</th>
                    <th class="text-start">{{ "Description" | translate | async }}</th>
                    <th class="text-end">{{ "Amount" | translate | async }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let products of orderReceipt.product"
                    class="th-border"
                  >
                    <td class="text-start">
                      <!-- &&
                            products.splitOrderIds?.length === 0 -->
                      <h6
                        class="mb-0"
                        [class]="validateProductRefundedcolor(products)"
                        *ngIf="
                          ((products?.splitOrderIds?.length === 0 ||
                            products?.splitOrderIds === null) &&
                            products?.productQuantity) ||
                          (products?.splitOrderIds?.length >= 1 && !(products?.splitOrderIds &&
                            products?.splitOrderIds?.length !== 0 &&
                            products?.productQuantity !==
                              products?.splitOrderIds?.length &&
                            products?.splitOrderIds.length !== 1))
                        "
                        [ngClass]="{ '': products.productSellStatus === 7 }"
                      >
                        {{ products.productQuantity }}
                      </h6>
                      <h6
                        [class]="validateProductRefundedcolor(products)"
                        class="mb-0"
                        *ngIf="
                          products?.splitOrderIds &&
                          products?.splitOrderIds?.length !== 0 &&
                          products?.productQuantity !==
                            products?.splitOrderIds?.length &&
                          products?.splitOrderIds.length !== 1
                        "
                        [ngClass]="{ '': products.productSellStatus === 7 }"
                      >
                        <ng-container>
                          <ng-container>
                            {{ products.productQuantity }}
                          </ng-container>
                          / {{ products.splitOrderIds.length }}
                        </ng-container>
                      </h6>
                    </td>
                    <td class="text-start">
                      <h6
                        [class]="validateProductRefundedcolor(products)"
                        [ngClass]="{ '': products.productSellStatus === 7 }"
                        class="mb-0"
                        [style.text-decoration]="
                          validateProductRefunded(products)
                        "
                      >
                        {{
                          (products.productName == ""
                            ? products.productVariantName
                            : products.productName) | translate | async
                        }}
                      </h6>
                      <h6 *ngIf="products.productVariantName"
                        [class]="validateProductRefundedcolor(products)"
                        [ngClass]="{ '': products.productSellStatus === 7 }"
                        class="mb-0"
                        [style.text-decoration]="
                          validateProductRefunded(products)
                        "
                      >
                        - {{ products.productVariantName | translate | async }}
                      </h6>
                      <div
                        class=""
                        style="text-align: left !important; padding-right: 10px"
                      >
                      <ng-container *ngIf="products.productDiscountValue">
                        <ng-container>
                          <div class="f-14 fw-500 d-flex justify-content-between">
                            <div>{{ "Discount" | translate | async }}
                              <br>
                              <span style="font-size: 14px;" class="fw-500">
                              {{ getProductLevelDiscountNames(products.productDiscount) | translate | async }}</span>
                            </div>
                          </div>
                        </ng-container>
                      </ng-container>
                      <ng-container *ngIf="products.AllproductModifiers">
                        <ng-container *ngFor="let modifiers of products.modifierGroupById">
                          <div class="f-14 fw-500 d-flex justify-content-between">
                            <div>
                              {{ modifiers.modifierName | translate | async }}
                            </div>
                          </div>
                          <ul *ngIf="modifiers.modifierOptions">
                            <li *ngFor="let option of modifiers.modifierOptions">
                              {{ option.modifierOptionName | translate | async }}
                            </li>
                          </ul>
                        </ng-container>
                      </ng-container>

                        <!-- <ng-container *ngIf="products.productModifiers">
                          <ng-container
                            *ngFor="let modifiers of products.productModifiers"
                          >
                            <div class="f-14 fw-500">
                              {{ modifiers.modifierName | translate | async }}
                              {{
                                modifiers.modifierPrice
                                  | currency : currency : "symbol" : "1.2-2"
                              }}
                            </div>
                            <ul *ngIf="modifiers.modifierOptionName">
                              <li>
                                {{ modifiers.modifierOptionName | translate | async }}
                              </li>
                            </ul>
                          </ng-container>
                        </ng-container> -->
                        <ng-container *ngIf="products.productAddons">
                          <ng-container *ngFor="let addons of products.addons">
                            <div class="f-14 fw-500" *ngIf="addons.addonName">
                              {{ addons.addonName | translate | async }}
                            </div>
                          </ng-container>
                        </ng-container>
                        <ng-container *ngIf="products.productIngredients">
                          <ng-container
                            *ngFor="
                              let ingredient of products.productIngredients
                            "
                          >
                            <div
                              [style.text-decoration]="
                                validateProductIngredients(ingredient)
                              "
                              class="f-14 fw-500"
                              *ngIf="ingredient.ingredientName"
                            >
                              {{ ingredient.ingredientName | translate | async }}
                            </div>
                          </ng-container>
                        </ng-container>
                      </div>
                      <div
                        style="text-align: left !important; padding-right: 10px"
                        *ngIf="products.note"
                      >
                        <div class="f-14 fw-500 text-secondary">
                          "{{ products.note | translate | async }}"
                        </div>
                      </div>
                    </td>
                    <td class="text-end" style="vertical-align: unset !important;">
                      <div
                        [class]="validateProductRefundedcolor(products)"
                        class="f-16 fw-600"
                        [style.text-decoration]="
                          validateProductRefunded(products)
                        "
                        [ngClass]="{
                          '':
                            products.productSellStatus === 7 ||
                            products.productSellStatus === 6
                        }"
                      >
                        {{
                          sum(
                            products.productUnitPrice,
                            products.productQuantity
                          ) | currency : currency : "symbol" : "1.2-2"
                        }}
                      </div>
                      <!--  -->
                      <!-- <div
                      *ngIf="products.productDiscountValue"
                        class="f-16 fw-600"
                      >
                        {{
                          products.productDiscountValue
                            | currency : currency : "symbol" : "1.2-2"
                        }}
                      </div> -->
                      <!--  -->
                      <!--  -->
                      <div
                      *ngIf="products.productDiscountValue && products.productModifiers"
                        class="f-16 fw-600"
                      ><br>
                      <br>
                      </div>
                      <!--  -->
                      <div
                        *ngFor="let modifiers of products.productModifiers; let j = index"
                        class="f-14 fw-600"
                        [style.text-decoration]="
                          validateProductRefunded(products)
                        "
                        [ngClass]="{
                          '':
                            products.productSellStatus === 7 ||
                            products.productSellStatus === 6
                        }"
                      >
                        <div *ngIf="j == 0"
                        >
                          <br>
                        </div>
                        <div *ngIf="newLine(modifiers)"
                        [class]="j > 1 ? 'f-21' : ''"
                        >
                          <br>
                        </div>
                        {{
                          modifiers.modifierPrice
                            | currency : currency : "symbol" : "1.2-2"
                        }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!-- <div class="f-20 fw-600" style="color: #000;">Total</div> -->
            <!-- <hr /> -->
          </div>
          <ng-container>
            <div>
              <div class="f-18 fw-600 d-flex justify-content-between text-grey">
                <div class="mb-1">{{ "Subtotal" | translate | async }}</div>
                <!-- FULL REFUND CHANGES -->
                <div class="mb-1">
                  {{
                    orderReceipt.orderSellStatus === 6
                      ? (0 | currency: currency: 'symbol':'1.2-2')
                      : (orderReceipt.subTotalAmount | currency: currency: 'symbol':'1.2-2')
                  }}
                </div>
              </div>
              <div
                class="f-18 fw-600 d-flex justify-content-between text-grey"
                *ngIf="deliveryAmount"
              >
                <div class="mb-1">{{ "Delivery Charges" | translate | async }}</div>

                <div class="mb-1">
                  {{
                    orderReceipt.orderSellStatus === 6
                      ? (0 | currency: currency: 'symbol':'1.2-2')
                      : (deliveryAmount | currency: currency: 'symbol':'1.2-2')
                  }}
                </div>
              </div>
              <div
                class="f-18 fw-600 d-flex justify-content-between text-grey"
                *ngIf="orderReceipt.promoCodeAmount"
              >
                <div class="mb-1">
                  {{ "Promo Code" | translate | async }}
                  <span
                    style="font-size: 14px"
                    class="fw-lighter"
                    *ngIf="orderReceipt.promoCode.type !== 1"
                  >
                    ({{ orderReceipt.promoCode.name }} @{{
                      orderReceipt.promoCode.value | number : "1.2-2"
                    }}{{ currency }})
                  </span>
                  <span
                    style="font-size: 14px"
                    class="fw-lighter"
                    *ngIf="orderReceipt.promoCode.type === 1"
                  >
                    ({{ orderReceipt.promoCode.name }} @{{
                      orderReceipt.promoCode.value
                    }}%)
                  </span>
                </div>
                <div class="mb-1">
                  {{
                    orderReceipt.orderSellStatus === 6
                      ? (0 | currency: currency: 'symbol':'1.2-2')
                      : (orderReceipt.promoCodeAmount | currency: currency: 'symbol':'1.2-2')
                  }}
                </div>
              </div>
              <div
                class="f-18 fw-600 d-flex justify-content-between text-grey"
                *ngIf="orderReceipt.taxAmount"
              >
                <div *ngIf="taxAliasValue == 'VAT'" class="mb-1 d-flex flex-wrap"  style="max-width: 400px;">
                 <div> {{ "VAT" | translate | async }}</div>
                 <div> <span style="font-size: 14px" class="fw-lighter"
                    >({{ getTaxNames() }})</span
                  ></div>
                </div>
                <div *ngIf="taxAliasValue == 'Tax'" class="mb-1 d-flex flex-wrap" style="max-width: 400px;">
                  <div>
                    {{ "Sales Tax" | translate | async }}
                  </div>
                  <div>
                    <span style="font-size: 14px" class="fw-lighter"
                    >({{ getTaxNames() | translate | async }})</span
                  >
                  </div>
                </div>
                <div *ngIf="taxAliasValue != 'VAT' && taxAliasValue != 'Tax'" class="mb-1">
                  {{ taxAliasValue ? taxAliasValue : 'Sales Tax' }}
                  <span style="font-size: 14px" class="fw-lighter"
                    >({{ getTaxNames() | translate | async }})</span
                  >
                </div>
                <!-- <div class="mb-1 order-sales-tax" style="max-width: 120px;  overflow: hidden !important;
  word-wrap: break-word !important;">
                  {{
                    orderReceipt.orderSellStatus === 6
                      ? (0 | currency: currency: 'symbol':'1.2-2')
                      : (orderReceipt.taxAmount | currency: currency: 'symbol':'1.2-2')
                  }}
                </div> -->



                <div class="mb-1 d-flex gap-1 order-sales-tax">
                  <div >
                    {{
                      currency
                    }}
                  </div>
                  <div class="vat-total-amount">
                    <span>
                      {{
                        (orderReceipt.orderSellStatus === 6
                          ? 0
                          : orderReceipt.taxAmount) | number: '1.2-2'
                      }}
                    </span>
                  </div>
                </div>
              </div>

              <div
                class="f-18 fw-600 d-flex justify-content-between text-grey"
                *ngIf="orderReceipt.orderServiceCharge.serviceChargeValue"
              >
                <div class="mb-1">
                  {{ "Service Charges" | translate | async }}
                  <span
                    style="font-size: 14px"
                    class="fw-lighter"
                    *ngIf="
                      orderReceipt.orderServiceCharge.serviceChargeType !== 1
                    "
                  >
                    ({{ orderReceipt.orderServiceCharge.serviceChargeName }} @ {{ currency }}{{
                      orderReceipt.orderServiceCharge.serviceChargeValue
                        | number : "1.2-2"
                    }})
                  </span>
                  <span
                    style="font-size: 14px"
                    class="fw-lighter"
                    *ngIf="
                      orderReceipt.orderServiceCharge.serviceChargeType === 1
                    "
                    style="font-size: 14px"
                    class="fw-lighter"
                  >
                    ({{ orderReceipt.orderServiceCharge.serviceChargeName }} @{{
                      orderReceipt.orderServiceCharge.serviceChargeValue
                    }}%)
                  </span>
                </div>
                <div class="mb-1">
                  {{
                    orderReceipt.orderSellStatus === 6
                      ? (0 | currency: currency: 'symbol':'1.2-2')
                      : (orderReceipt.serviceChargeAmount | currency: currency: 'symbol':'1.2-2')
                  }}
                </div>
              </div>
              <div
                class="f-18 fw-600 d-flex justify-content-between text-grey"
                *ngIf="orderReceipt.discountAmount"
              >
                <div class="mb-1 d-flex flex-wrap" style="max-width: 400px;">
                  <!-- class="... discount-width" -->
                  <div>{{ "Discount" | translate | async }}</div>
                  <!--  class="... discount-width" -->
                 <div>
                  <!-- class="... discount-width" -->
                  <span
                  style="font-size: 14px"
                  class="fw-lighter"
                  *ngIf="_getDiscountNames"
                  [innerHTML]="(_getDiscountNames | translate | async)"
                ></span>
                <!-- class="... discount-width" -->
                <span
                  style="font-size: 14px"
                  class="fw-lighter "
                  *ngIf="orderReceipt.globalDiscount.discountType !== 1"
                >
                  <ng-container
                    *ngIf="
                      orderReceipt.globalDiscount?.discountName &&
                      orderReceipt.globalDiscount.discountValue
                    "
                  >
                    ({{ orderReceipt.globalDiscount?.discountName }} @ {{ currency }}{{
                      orderReceipt.globalDiscount.discountValue
                        | number : "1.2-2"
                    }})
                  </ng-container>
                </span>
                <!-- class="... discount-width" -->
                <span
                  style="font-size: 14px"
                  class="fw-lighter"
                  *ngIf="orderReceipt.globalDiscount.discountType === 1"
                >
                  <ng-container
                    *ngIf="
                      orderReceipt.globalDiscount?.discountName &&
                      orderReceipt.globalDiscount.discountValue
                    "
                  >
                    ({{ orderReceipt.globalDiscount?.discountName }} @{{
                      orderReceipt.globalDiscount.discountValue
                    }}%)
                  </ng-container>
                </span>
                 </div>
                </div>
                <div class="mb-1 payment-AED">
                  {{
                    orderReceipt.orderSellStatus === 6
                      ? (0 | currency: currency: 'symbol':'1.2-2')
                      : (orderReceipt.discountAmount | currency: currency: 'symbol':'1.2-2')
                  }}
                </div>
              </div>
              <div
                class="f-18 fw-600 d-flex justify-content-between mb-3 text-grey"
                *ngIf="orderReceipt.totalTip"
              >
                <div class="mb-1">{{ "Tips" | translate | async }}</div>

                <div class="mb-1">
                  {{
                    orderReceipt.orderSellStatus === 6
                      ? (0 | currency: currency: 'symbol':'1.2-2')
                      : (orderReceipt.totalTip | currency: currency: 'symbol':'1.2-2')
                  }}
                </div>
              </div>
              <div
                class="f-24 fw-700 d-flex justify-content-between mb-3 total-amount"
              >
                <div class="mb-1">{{ "Total Amount" | translate | async }}</div>

                <div class="mb-1 payment-total-amount">
                  {{
                    orderReceipt.orderSellStatus === 6
                      ? (0 | currency: currency: 'symbol':'1.2-2')
                      : (orderReceipt.totalAmount | currency: currency: 'symbol':'1.2-2')
                  }}
                </div>
              </div>
              <div class="row order-refund">
                <div class="col-sm-6 mb-3">
                  <button
                    module="Order"
                    class="w-100 btn w-100 f-18 fw-600 bg-gray grey_btn_theme"
                    (click)="fullrefund(orderReceipt, 'partial')"
                    [disabled]="
                      orderReceipt.orderSellStatus !== 4 &&
                      orderReceipt.orderSellStatus !== 5
                    "
                  >
                    {{ "PARTIAL REFUND" | translate | async }}
                  </button>
                </div>
                <div class="col-sm-6 mb-3 send-receipt">
                  <button
                    accessControl
                    module="SalesTransaction"
                    access="3"
                    class="btn f-18 fw-600 bg-gray grey_btn_theme"
                    [disabled]="
                      orderReceipt.orderSellStatus != 4 &&
                      orderReceipt.orderSellStatus != 5
                    "
                    (click)="sendReceipt(orderReceipt)"
                  >
                    {{ "SEND RECEIPT" | translate | async }}
                  </button>
                </div>
                <div class="col-sm-6 mb-3">
                  <button
                    access="3"
                    accessControl
                    module="Order"
                    class="w-100 btn w-100 f-18 fw-600 bg-gray grey_btn_theme"
                    (click)="openEnd(Editorder)"
                    [disabled]="
                      orderReceipt.orderSellStatus != 4 &&
                      orderReceipt.orderSellStatus != 5
                    "
                  >
                    {{ (editOrderLoader ? "Please wait..." : "EDIT ORDER") | translate | async }}
                  </button>
                </div>
                <div class="col-sm-6 mb-3">
                  <button
                    module="Order"
                    class="w-100 btn w-100 f-18 fw-600 bg-gray grey_btn_theme"
                    (click)="fullrefund(orderReceipt, 'full')"
                    [disabled]="
                      orderReceipt.orderSellStatus !== 4 &&
                      orderReceipt.orderSellStatus !== 5
                    "
                  >
                    {{ "FULL REFUND" | translate | async }}
                  </button>
                </div>

                <div class="col-sm-6 mb-3">
                  <div *ngIf="!closeOrderLoader">
                    <!--
                      Removed:
                        access="3"
                        accessControl
                      Added:
                        [disabled]="disableCloseBtn"
                        [style.background-color]="disableCloseBtn ? '#6e6e6e !important' : ''"
                     -->
                    <button
                      [disabled]="disableCloseBtn"
                      [style.background-color]="disableCloseBtn ? '#6e6e6e !important' : ''"
                      module="Order"
                      class="w-100 btn w-100 f-18 fw-600 bg-gray close-order"
                      (click)="closeOrder(orderReceipt)"
                      *ngIf="
                        (orderReceipt.orderStatusName == 'Paid' ||
                          orderReceipt.orderStatusName == 'Completed' ||
                          orderReceipt.orderStatusName ==
                            'Partially refunded' ||
                          orderReceipt.orderStatusName == 'Refunded' ||
                          orderReceipt.orderStatusName == 'Cancelled') &&
                        orderReceipt.orderSellStatus != 4
                      "
                    >
                      {{ "CLOSE ORDER" | translate | async }}
                    </button>
                    <button
                      accessControl
                      module="Order"
                      access="3"
                      class="w-100 btn w-100 f-18 fw-600 bg-gray close-order close-order-disabled"
                      disabled
                      style="cursor: default; background: #6E6E6E !important;"
                      *ngIf="
                        (orderReceipt.orderStatusName == 'Completed' &&
                          orderReceipt.orderSellStatus == 4) ||
                        orderReceipt.orderStatusName == 'Ordering'
                      "
                    >
                      {{ "CLOSE ORDER" | translate | async }}
                    </button>
                    <!-- Removed:
                      access="3"
                      accessControl
                     -->
                    <button
                      module="Order"
                      class="w-100 close_btn_theme text-white w-100 f-18 fw-600"
                      [disabled]="disableCloseBtn"
                      [style.background-color]="disableCloseBtn ? '#6e6e6e !important' : ''"
                      (click)="closeOrder(orderReceipt)"
                      *ngIf="
                        orderReceipt.orderStatusName != 'Paid' &&
                        orderReceipt.orderStatusName != 'Completed' &&
                        orderReceipt.orderStatusName != 'Partially refunded' &&
                        orderReceipt.orderStatusName != 'Refunded' &&
                        orderReceipt.orderStatusName != 'Cancelled' &&
                        orderReceipt.orderStatusName != 'Ordering'
                      "
                    >
                      {{ "CLOSE ORDER" | translate | async }}
                    </button>
                  </div>
                  <button
                    *ngIf="closeOrderLoader"
                    class="primary_btn f-14 w-100 fw-700 text-white"
                    type="button"
                    disabled
                  >
                    <span
                      class="spinner-grow spinner-grow-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    <span class="pl-2">&nbsp;&nbsp;{{ "Please wait..." | translate | async }}</span>
                  </button>
                </div>
              </div>
              <!-- <div class="col-sm-6 mb-3 send-receipt">
                <button
                  accessControl
                  module="SalesTransaction"
                  access="3"
                  class="btn f-18 fw-600 bg-gray grey_btn_theme"
                  [disabled]="
                    orderReceipt.orderSellStatus != 4 &&
                    orderReceipt.orderSellStatus != 5
                  "
                  (click)="sendReceipt(orderReceipt)"
                >
                  {{ "SEND RECEIPT" | translate | async }}
                </button>
              </div> -->
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="showEditPageDetails">
          <div>
            <div
              class="d-flex justify-content-between mb-4 align-items-center position-relative"
            >
              <ng-container>
                <div class="d-flex align-items-center gap-3">
                  <span class="back-btn fs-5" (click)="backtoOrderDetails()"
                    ><i class="fas fa-arrow-left"></i
                  ></span>
                  <h1 class="modal-title text-center w-100 fw-700">
                    {{ "Edit Receipt" | translate | async }}
                  </h1>
                </div>
              </ng-container>
              <div class="align-self-center">
                <button
                  type="button"
                  class="btn-close f-14"
                  aria-label="Close"
                  (click)="
                    closeModal(content); offcanvasService.dismiss('Cross click')
                  "
                ></button>
              </div>
            </div>
            <div class="mb-3 f-16 fw-500">
              <div class="d-flex justify-content-between mb-2">
                <div>
                  {{ "Order # :" | translate | async }}<b> {{ orderReceipt.orderNumber }}</b>
                </div>
                <div *ngIf="orderReceipt.createdAt == 0">---------</div>
                <div *ngIf="orderReceipt.createdAt != 0" class="text-uppercase">
                  {{
                    _convertDate(orderReceipt.orderId, orderReceipt.createdAt) | translate | async
                  }}
                </div>
              </div>
              <div class="d-flex justify-content-between mb-2">
                <div>
                  {{ "Check ID :" | translate | async }}<b> {{ orderReceipt.paymentNumber }}</b>
                </div>
                <div class="text-uppercase">
                  {{
                    _convertTime(orderReceipt.orderId, orderReceipt.createdAt) | translate | async
                  }}
                </div>
              </div>
              <div class="mb-2" *ngIf="orderReceipt.serverId !== null">
                {{ "Customer Name :" | translate | async }}
                <b
                  >{{ orderReceipt.customerFirstName }}
                  {{ orderReceipt.customerLastName }}</b
                >
              </div>
              <div class="mb-2" *ngIf="orderReceipt.serverId === null">
                {{ "Customer Name :" | translate | async }} <b>{{ "No Customer" | translate | async }}</b>
              </div>
              <div class="mb-2" *ngIf="orderReceipt.serverId !== null">
                {{ "Employee Name :" | translate | async }}
                <b
                  >{{ orderReceipt?.serverId?.employeeFirstName }}
                  {{ orderReceipt?.serverId?.employeeLastName }}</b
                >
              </div>
              <div class="mb-2" *ngIf="orderReceipt.serverId === null">
                {{ "Employee Name :" | translate | async }} <b></b>
              </div>
            </div>
            <ng-container
              *ngIf="orderEditModalPageOne || orderEditModalPageTwo"
            >
              <app-transaction-order-edit-shared
                [timeToVerify]="timeToVerify"
                [timerDisplay]="timerDisplay"
                [buttonApprove]="buttonApprove"
                (otpEmit)="isVerificationOk($event)"
                (nextPage)="nextPage()"
                [orderEditModalPageOne]="orderEditModalPageOne"
                [orderEditModalPageTwo]="orderEditModalPageTwo"
                [currency]="currency"
                [paymentReceipt]="paymentReceipt"
                (selectTransactionEditOrder)="
                  selectTransactionEditOrder($event)
                "
                [orderEditModalPageThree]="orderEditModalPageThree"
                [employees]="activeEmployees$"
                [userSelected]="userSelected"
                (changeValueSelect)="changeValueSelect($event)"
                [editPayment]="editPayment"
                [tipAmount]="tipAmount"
                (changeAmount)="changeEditTipAmount($event)"
                (changeTipFunction)="changeTipFunction(content)"
                [chageLoader]="chageLoader"
                (resendOtpEditOrder)="resendOtpEditOrder()"
              ></app-transaction-order-edit-shared>
            </ng-container>
          </div>
        </ng-container>
        <ng-container *ngIf="showReceiptPage">
          <div>
            <div class="d-flex justify-content-between mb-4">
              <ng-container>
                <span class="back-btn fs-5" (click)="backtoOrderDetails()"
                  ><i class="fas fa-arrow-left"></i
                ></span>
                <h1 class="modal-title text-center w-100 fw-700">
                  {{ "Send Receipt" | translate | async }}
                </h1>
              </ng-container>
              <div class="align-self-center">
                <button
                  type="button"
                  class="btn-close f-14"
                  aria-label="Close"
                  (click)="
                    closeModal(content); offcanvasService.dismiss('Cross click')
                  "
                ></button>
              </div>
            </div>
            <div class="mb-3 f-14 fw-500">
              <div class="d-flex justify-content-between mb-1">
                <div>
                  {{ "Order # :" | translate | async }}<b> {{ orderReceipt.orderNumber }}</b>
                </div>
                <div *ngIf="orderReceipt.createdAt == 0">---------</div>
                <div *ngIf="orderReceipt.createdAt != 0">
                  {{
                    _convertDate(orderReceipt.orderId, orderReceipt.createdAt) | translate | async
                  }}
                </div>
              </div>
              <div class="d-flex justify-content-between mb-1">
                <div>
                  {{ "Check ID :" | translate | async }}<b> {{ orderReceipt.paymentNumber }}</b>
                </div>
                <div>
                  {{
                    _convertTime(orderReceipt.orderId, orderReceipt.createdAt) | translate | async
                  }}
                </div>
              </div>
              <div class="mb-1" *ngIf="orderReceipt.serverId !== null">
                {{ "Customer Name :" | translate | async }}
                <b
                  >{{ orderReceipt.customerFirstName }}
                  {{ orderReceipt.customerLastName }}</b
                >
              </div>
              <div class="mb-1" *ngIf="orderReceipt.serverId === null">
                {{ "Customer Name :" | translate | async }} <b>{{ "No Customer" | translate | async }}</b>
              </div>
              <div class="mb-1" *ngIf="orderReceipt.serverId !== null">
                {{ "Employee Name :" | translate | async }}
                <b
                  >{{ orderReceipt?.serverId?.employeeFirstName }}
                  {{ orderReceipt?.serverId?.employeeLastName }}</b
                >
              </div>
              <div class="mb-1" *ngIf="orderReceipt.serverId === null">
                {{ "Employee Name :" | translate | async }} <b></b>
              </div>
            </div>
            <div class="receipt-send-box order-width">
              <h3 class="w-100 text-center mb-2 total-text">{{ "Total" | translate | async }}</h3>
              <h1 class="w-100 text-center receipt-amount">
                {{ globalamount | currency : currency : "symbol" : "1.2-2" }}
              </h1>
              <div class="send-inputs">
                <span
                  class="d-inline-block w-100 text-center text-bold mb-3 receipt-info-text"
                  >{{ "How do you want to receive your receipts?" | translate | async }}</span
                >
                <hr style="margin-top: 0px" />
                <div class="form-group mb-2">
                  <label>{{ "Email" | translate | async }}</label>
                  <div class="input-group">
                    <span class="input-group-text bg-transparent border-end-0"
                      ><i class="fas fa-envelope"></i
                    ></span>
                    <input
                      type="text"
                      class="form-control border-end-0 border-start-0"
                      [placeholder]="'Email' | translate | async"
                      aria-label="Email"
                      aria-describedby="basic-addon2"
                      id="email"
                      name="email"
                      [(ngModel)]="email"
                      (ngModelChange)="validateEmail()"
                      autocomplete="autocomplete_off_randString"
                    />
                    <button
                      accessControl
                      module="Order"
                      access="3"
                      style="background-color: #000; color: #fff"
                      class="input-group-text fw-600 eatos-submit-btn"
                      id="basic-addon2"
                      [disabled]="
                        emailMsg != '' || email == '' || !disableSendbtn
                      "
                      (click)="sendReceiptToEmail()"
                    >
                      {{ "Send" | translate | async }}
                    </button>
                  </div>
                  <span class="mt-1 input-invalid-error">{{ emailMsg }}</span>
                </div>
                <div class="form-group">
                  <label>{{ "Phone Number" | translate | async }}</label>
                  <div class="custom-intl-input-group">
                    <ngx-intl-tel-input
                      [cssClass]="'form-control input-group-intl'"
                      [preferredCountries]="preferredCountries"
                      [enableAutoCountrySelect]="true"
                      [enablePlaceholder]="true"
                      [searchCountryFlag]="true"
                      [searchCountryField]="[
                        SearchCountryField?.Iso2,
                        SearchCountryField.Name
                      ]"
                      [phoneValidation]="true"
                      name="phone"
                      [(ngModel)]="phone"
                      (ngModelChange)="validatePhone()"
                      autocomplete="autocomplete_off_randString"
                    >
                    </ngx-intl-tel-input>
                    <button
                      accessControl
                      module="Order"
                      access="3"
                      class="input-group-text fw-600 btn-pink eatos-submit-btn"
                      [disabled]="phoneMsg || phone == null"
                      id="basic-addon2"
                      (click)="sendReceiptMobile()"
                    >
                      {{ "Send" | translate | async }}
                    </button>
                  </div>
                  <span *ngIf="phoneMsg" class="mt-1 input-invalid-error"
                    >{{ "Mobile number is not of selected country" | translate | async }}</span
                  >
                </div>
                <p class="text-center mt-2 receipt-disclaimer">
                  {{ "Digital receipts delivered by eatOS. See your digital receipt for privacy policy and preferences." | translate | async }}
                </p>
              </div>
            </div>
          </div>
        </ng-container>
        <ng-container *ngIf="showRefundPage">
          <div
            class="d-flex justify-content-between mb-4 align-items-center close-icon"
          >
            <ng-container *ngIf="!showRefundLoader && !showRefundSuccess">
              <span
                *ngIf="!showRefundPageTwo"
                class="back-btn fs-5"
                (click)="backtoOrderDetails()"
                ><i class="fas fa-arrow-left f-14"></i
              ></span>
              <span
                *ngIf="showRefundPageTwo"
                class="back-btn fs-5"
                (click)="backtoRefundPageOne()"
                ><i class="fas fa-arrow-left f-14"></i
              ></span>
              <h1
                *ngIf="fundType == 'FULL REFUND'"
                class="modal-title text-center w-100 fw-700"
                style="color: #d50000"
              >
                {{ fundType | translate | async}}
              </h1>
              <h1
                *ngIf="fundType == 'PARTIAL REFUND'"
                class="modal-title text-center w-100 fw-700"
                style="color: #b5b6b7"
              >
                {{ fundType | translate | async }}
              </h1>
            </ng-container>
            <div class="align-self-center">
              <button
                type="button"
                class="btn-close f-14"
                aria-label="Close"
                (click)="
                  closeModal(content); offcanvasService.dismiss('Cross click')
                "
              ></button>
            </div>
          </div>
          <div class="mb-3 f-14 fw-500">
            <div class="d-flex justify-content-between mb-1">
              <div>
                {{ "Order # :" | translate | async }}<b> {{ orderReceipt.orderNumber }}</b>
              </div>
              <div *ngIf="orderReceipt.createdAt == 0">---------</div>
              <div *ngIf="orderReceipt.createdAt != 0">
                {{ _convertDate(orderReceipt.orderId, orderReceipt.createdAt) | translate | async }}
              </div>
            </div>
            <div class="d-flex justify-content-between mb-1">
              <div>
                {{ "Check ID :" | translate | async }}<b> {{ orderReceipt.paymentNumber }}</b>
              </div>

              <div>
                {{ _convertTime(orderReceipt.orderId, orderReceipt.createdAt) | translate | async }}
              </div>
            </div>
            <div class="mb-1" *ngIf="orderReceipt.serverId !== null">
              {{ "Customer Name :" | translate | async }}
              <b
                >{{ orderReceipt.customerFirstName }}
                {{ orderReceipt.customerLastName }}</b
              >
            </div>
            <div class="mb-1" *ngIf="orderReceipt.serverId === null">
              {{ "Customer Name :" | translate | async }} <b>{{ "No Customer" | translate | async }}</b>
            </div>
            <div class="mb-1" *ngIf="orderReceipt.serverId !== null">
              {{ "Employee Name :" | translate | async }}
              <b
                >{{ orderReceipt?.serverId?.employeeFirstName }}
                {{ orderReceipt?.serverId?.employeeLastName }}</b
              >
            </div>
            <div class="mb-1" *ngIf="orderReceipt.serverId === null">
              {{ "Employee Name :" | translate | async }} <b></b>
            </div>
          </div>
          <hr style="margin-top: 0px" />
          <div
            class="receipt-send-box loader-box"
            *ngIf="showRefundLoader || showRefundSuccess"
          >
            <ng-container *ngIf="showRefundSuccess">
              <div
                class="success-icon d-flex align-items-center justify-content-center"
              >
                <img
                  src="../../../../../assets/images/sucess-icon.png"
                  alt=""
                />
              </div>
              <h3 class="tefund-text">{{ "Refund Successful" | translate | async }}</h3>
              <p class="fw-500 mb-4 p-text">
                {{ "A refund of" | translate | async }}
                <!-- <span style="color: #d50000">{{
                  globalamount | currency : currency : "symbol" : "1.2-2"
                }}</span> -->
                <span style="color: #d50000"

                >{{ currency }}{{ globalamount | number: "1.2-2" }}</span>
                {{ "will be applied to the original payment method for the order" | translate | async }}
              </p>
            </ng-container>
            <ng-container *ngIf="showRefundLoader">
              <div class="spinner-border color-red mb-4" role="status">
                <span class="sr-only">{{ "Loading..." | translate | async }}</span>
              </div>
              <div class="f-20 fw-600 mb-3">{{ "Refund Processing..." | translate | async }}</div>
              <p class="fw-500 mb-4 text-center">
                {{ "Your refund request is currently being processed. Please wait..." | translate | async }}
              </p>
            </ng-container>
            <ng-container *ngIf="showRefundSuccess"></ng-container>
          </div>
          <div class="space-blocker"></div>

          <div
            class="receipt-send-box"
            style="padding: 0px; margin-top: 0px"
            *ngIf="!showRefundLoader && !showRefundSuccess"
          >
            <h1
              class="w-100 fw-600 text-center my-4 fullrefund-total-data"
              *ngIf="!showRefundPageTwo && fundType == 'FULL REFUND'"
            >
              {{ globalamount | currency : currency : "symbol" : "1.2-2" }}
            </h1>
            <h1
              class="w-100 fw-600 text-center my-4 fullrefund-total-data"
              *ngIf="!showRefundPageTwo && fundType == 'PARTIAL REFUND'"
            >
              {{
                pRefundModalAmount | currency : currency : "symbol" : "1.2-2"
              }}
            </h1>
            <div class="row" *ngIf="!showRefundPageTwo">
              <div class="col">
                <table class="table order-detail-table">
                  <thead>
                    <tr>
                      <th
                        *ngIf="fundType != 'FULL REFUND'"
                        class="text-center"
                      ></th>
                      <th class="text-center">{{ "Qty" | translate | async }}</th>
                      <th class="text-center">{{ "Description" | translate | async }}</th>
                      <th class="text-end">{{ "Amount" | translate | async }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container *ngFor="let product of orderReceipt.seats">
                      <tr
                        *ngFor="
                          let products of product.orderProducts;
                          let i = index
                        "
                      >
                        <!-- <td class="text-center">
                        <h6
                          *ngIf="products.splitOrderIds && products.productQuantity && products.splitOrderIds.length === 0 ||
                              products.productQuantity && products.splitProductOriginId !== null   && products.splitOrderIds.length === 0  "
                          [ngClass]="{'text-danger': products.productSellStatus === 7}">
                          {{products.productQuantity}}
                        </h6>
                      </td> -->
                        <td
                          *ngIf="fundType != 'FULL REFUND'"
                          class="text-center"
                        >
                          <ng-container
                            *ngIf="products.productSellStatus !== 6"
                          >
                            <input
                              class="red-chek form-check-input"
                              type="checkbox"
                              [disabled]="products.productUnitPrice == 0 || products.productSellStatus === 7 || products.productSellStatus === 6"
                              value=""
                              [id]="'flexCheckChecked' + i"
                              [checked]="isCheckedFunc(products)"
                              (click)="
                                addProductsInListToRefund(products, $event)
                              "
                            />
                          </ng-container>
                        </td>
                        <td
                          class="text-center"
                          *ngIf="products.productQuantity"
                          [ngClass]="{
                            'text-danger':
                              products.productSellStatus === 7 ||
                              products.productSellStatus === 6
                          }"
                        >
                          <ng-container *ngIf="fundType == 'FULL REFUND'">
                            <h6>{{ products.productQuantity }}</h6>
                          </ng-container>
                          <ng-container
                            *ngIf="
                              !products.splitOrderIds ||
                              products.splitOrderIds.length === 0
                            "
                          >
                            <select
                              [disabled]="products.productSellStatus === 7 ||products.productSellStatus === 6 || products.productUnitPrice == 0"
                              *ngIf="fundType != 'FULL REFUND'"
                              (ngModelChange)="
                                addProductsInListToRefund2(products, $event)
                              "
                              [(ngModel)]="
                                selectedQuantity[products.orderedProductId]
                              "
                            >
                              <option
                                *ngFor="
                                  let quantity of getQuantityList(products)
                                "
                                value="{{ quantity }}"
                              >
                                {{ quantity }}
                              </option>
                            </select>
                          </ng-container>
                          <ng-container
                            *ngIf="
                              products.splitOrderIds &&
                              products.splitOrderIds.length !== 0 &&
                              products.productQuantity ===
                                products.splitOrderIds.length
                            "
                          >
                            1
                          </ng-container>
                          <!--
                              products.productQuantity !==
                                products.splitOrderIds.length &&
                              products.splitOrderIds.length !== 1 &&
                           -->
                          <ng-container
                            *ngIf="
                              products.splitOrderIds &&
                              products.splitOrderIds.length !== 0 &&
                              fundType != 'FULL REFUND'
                            "
                          >
                            <select
                              (ngModelChange)="
                                addProductsInListToRefund2(products, $event)
                              "
                              [(ngModel)]="
                                selectedQuantity[products.orderedProductId]
                              "
                            >
                              <option
                                *ngFor="
                                  let quantity of getQuantityList(products)
                                "
                                value="{{ quantity }}"
                              >
                                {{ quantity }}
                              </option>
                            </select>
                            <!-- <ng-container *ngIf="!pRefundModalPageOne">
                          {{ variants.productQuantity }}
                        </ng-container>
                        /{{variants.splitOrderIds.length}}
                        </ng-container> -->
                            <ng-container
                              *ngIf="
                                products.splitOrderIds &&
                                products.splitOrderIds.length !== 0 &&
                                products.productQuantity !==
                                  products.splitOrderIds.length &&
                                products.splitOrderIds.length === 1 &&
                                fundType == 'FULL REFUND'
                              "
                            >
                              <h6>{{ products.productQuantity }}</h6>
                            </ng-container>
                          </ng-container>
                        </td>

                        <td class="text-center">
                          <h6
                            [ngClass]="{
                              'text-danger': products.productSellStatus === 7
                            }"
                            [style.text-decoration]="
                              validateProductRefunded(products)
                            "
                          >
                            {{
                              (products.productName == ""
                                ? products.productVariantName
                                : products.productName) | translate | async
                            }}
                          </h6>
                          <div
                            class=""
                            style="
                              text-align: left !important;
                              padding-right: 10px;
                            "
                          >
                            <ul
                              style="
                                text-transform: uppercase;
                                list-style: none;
                                margin: 0;
                                padding: 0;
                              "
                            >
                              <ng-container *ngIf="products.productModifiers">
                                <li
                                  *ngFor="
                                    let modifiers of products.productModifiers
                                  "
                                >
                                  <ul class="lidot">
                                    <li>
                                      <span
                                        style="font-size: 16px; color: #9b9b9b"
                                        >{{ modifiers.modifierName | translate | async }}</span
                                      >
                                    </li>
                                  </ul>
                                </li>
                              </ng-container>
                              <ng-container *ngIf="products.productAddons">
                                <li *ngFor="let addons of products.addons">
                                  <ul class="lipositive">
                                    <li *ngIf="addons.name">
                                      <span
                                        style="font-size: 16px; color: #9b9b9b"
                                        >{{ addons.name | translate | async }}</span
                                      >
                                    </li>
                                  </ul>
                                </li>
                              </ng-container>
                            </ul>
                            <ng-container *ngIf="products.productIngredients">
                              <ul
                                style="
                                  list-style: none;
                                  text-transform: uppercase;
                                  padding: 0;
                                "
                              >
                                <li
                                  *ngFor="
                                    let ingredient of products.productIngredients
                                  "
                                >
                                  <ul class="linegative">
                                    <li>
                                      <span
                                        [style.text-decoration]="
                                          validateProductIngredients(ingredient)
                                        "
                                        style="font-size: 16px; color: #9b9b9b"
                                        >{{ ingredient.ingredientName | translate | async }}</span
                                      >
                                    </li>
                                  </ul>
                                </li>
                              </ul>
                            </ng-container>
                          </div>
                        </td>
                        <td class="text-center">
                          <h6
                            style="font-weight: bold; word-break: break-all"
                            class="mb-0"
                            [ngClass]="{
                              'item-replaced': products.productSellStatus === 7
                            }"
                          >
                            {{
                              sum(
                                products.productUnitPrice,
                                products.productQuantity
                              ) | currency : currency : "symbol" : "1.2-2"
                            }}
                          </h6>
                        </td>
                      </tr>
                    </ng-container>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="send-inputs mt-0" *ngIf="showRefundPageTwo">
              <div class="text-red fw-600 mb-3" style="font-size: 14px">
                {{ "Select a Reason for Refund" | translate | async }}
              </div>

              <div class="reason_list mb-3">
                <ng-container
                  *ngFor="let option of refundOptions; let i = index"
                >
                  <div class="form-check">
                    <label class="form-check-label">
                      <input
                        class="red-chek form-check-input ms-1 me-3 redio_theme"
                        type="radio"
                        name="uniqueradio"
                        value="{{ option }}"
                        [(ngModel)]="refundReason"
                        (ngModelChange)="getReason($event)"
                      />
                      {{ option | translate | async }}
                    </label>
                  </div>
                </ng-container>
              </div>

              <div class="mb-3">
                <textarea
                  rows="5"
                  maxlength="200"
                  [placeholder]="'Add any extra refund notes.' | translate | async"
                  class="form-control text-area-theme"
                  id="message-text"
                  value=""
                  [(ngModel)]="noteReason"
                  (ngModelChange)="getReasonNote($event)"
                ></textarea>
                <div>{{ 200 - noteReason.length }}/200</div>
              </div>
            </div>
          </div>
          <div class="space-blocker"></div>

          <ng-container *ngIf="!showRefundLoader && !showRefundSuccess">
            <ng-container *ngIf="!showRefundPageTwo">
              <!-- <div class="f-20 fw-600 text-black">{{ "Total" | translate | async }}</div> -->
              <hr />
            <div style="width: 100%; height: 30px; margin: 15px 0;"></div>

               <div class="f-14 fw-600 d-flex justify-content-between">
                <div class="mb-1">{{ "Subtotal" | translate | async }}</div>

                <div class="mb-1 payment-AED">
                  {{
                    orderReceipt.orderSellStatus === 6
                      ? (0 | currency: currency: 'symbol':'1.2-2')
                      : (orderReceipt.subTotalAmount | currency: currency: 'symbol':'1.2-2')
                  }}
                </div>
              </div>
              <div
                class="f-14 fw-600 d-flex justify-content-between"
                *ngIf="deliveryAmount"
              >
                <div class="mb-1">{{ "Delivery Charges" | translate | async }}</div>
                <div class="mb-1 payment-AED">
                  {{
                    orderReceipt.orderSellStatus === 6
                      ? (0 | currency: currency: 'symbol':'1.2-2')
                      : (deliveryAmount | currency: currency: 'symbol':'1.2-2')
                  }}
                </div>
              </div>
              <div
                class="f-14 fw-600 d-flex justify-content-between"
                *ngIf="orderReceipt.promoCodeAmount"
              >
                <div class="mb-1">
                  {{ "Promo Code" | translate | async }}
                  <span *ngIf="orderReceipt.promoCode.type !== 1">
                    ({{ orderReceipt.promoCode.name }} @{{
                      orderReceipt.promoCode.value | number : "1.2-2"
                    }}{{ currency }})
                  </span>
                  <span *ngIf="orderReceipt.promoCode.type === 1">
                    ({{ orderReceipt.promoCode.name }} @{{
                      orderReceipt.promoCode.value
                    }}%)
                  </span>
                </div>
                <div class="mb-1">
                  {{
                    orderReceipt.orderSellStatus === 6
                      ? (0 | currency: currency: 'symbol':'1.2-2')
                      : (orderReceipt.promoCodeAmount | currency: currency: 'symbol':'1.2-2')
                  }}
                </div>
              </div>
              <div
                class="f-14 fw-600 d-flex justify-content-between"
                *ngIf="orderReceipt.taxAmount"
              >
              <div *ngIf="taxAliasValue == 'VAT'" class="mb-1">
                {{ "VAT" | translate | async }}
                <span style="font-size: 14px" class="fw-lighter"
                  >({{ getTaxNames() }})</span
                >
              </div>
              <div *ngIf="taxAliasValue == 'Tax'" class="mb-1">
                {{ "Sales Tax" | translate | async }}
                <span style="font-size: 14px" class="fw-lighter"
                  >({{ getTaxNames() }})</span
                >
              </div>
              <div *ngIf="taxAliasValue != 'VAT' && taxAliasValue != 'Tax'" class="mb-1">
                {{ taxAliasValue ? taxAliasValue : 'Sales Tax' }}
                <span style="font-size: 14px" class="fw-lighter"
                  >({{ getTaxNames() }})</span
                >
              </div>
              <div class="mb-1">
                {{
                  orderReceipt.orderSellStatus === 6
                    ? (0 | currency: currency: 'symbol':'1.2-2')
                    : (orderReceipt.taxAmount | currency: currency: 'symbol':'1.2-2')
                }}
              </div>
              </div>

              <div
                class="f-14 fw-600 d-flex justify-content-between"
                *ngIf="orderReceipt.orderServiceCharge.serviceChargeValue"
              >
                <div class="mb-1">
                  {{ "Service Charges" | translate | async }}
                  <span
                    *ngIf="
                      orderReceipt.orderServiceCharge.serviceChargeType !== 1
                    "
                  >
                    ({{ orderReceipt.orderServiceCharge.serviceChargeName }} @{{
                      orderReceipt.orderServiceCharge.serviceChargeValue
                        | number : "1.2-2"
                    }}{{ currency }})
                  </span>
                  <span
                    *ngIf="
                      orderReceipt.orderServiceCharge.serviceChargeType === 1
                    "
                  >
                    ({{ orderReceipt.orderServiceCharge.serviceChargeName }} @{{
                      orderReceipt.orderServiceCharge.serviceChargeValue
                    }}%)
                  </span>
                </div>
                <div class="mb-1">
                  {{
                    orderReceipt.orderSellStatus === 6
                      ? (0 | currency: currency: 'symbol':'1.2-2')
                      : (orderReceipt.serviceChargeAmount | currency: currency: 'symbol':'1.2-2')
                  }}
                </div>
              </div>
              <div
                class="f-14 fw-600 d-flex justify-content-between"
                *ngIf="orderReceipt.discountAmount"
              >
                <span *ngIf="orderReceipt.globalDiscount.discountType !== 1">
                  {{ "Discount" | translate | async }} ({{ orderReceipt.globalDiscount?.discountName | translate | async }} @{{
                    orderReceipt.globalDiscount.discountValue
                      | number : "1.2-2"
                  }}{{ currency }})
                </span>
                <span *ngIf="orderReceipt.globalDiscount.discountType === 1">
                  {{ "Discount" | translate | async }} ({{ orderReceipt.globalDiscount?.discountName | translate | async }} @{{
                    orderReceipt.globalDiscount.discountValue
                  }}%)
                </span>
                <div class="mb-1">
                  {{
                    orderReceipt.orderSellStatus === 6
                      ? (0 | currency: currency: 'symbol':'1.2-2')
                      : (orderReceipt.discountAmount | currency: currency: 'symbol':'1.2-2')
                  }}
                </div>
              </div>
              <div
                class="f-14 fw-600 d-flex justify-content-between mb-3"
                *ngIf="orderReceipt.totalTip"
              >
                <div class="mb-1">{{ "Tips" | translate | async }}</div>
                <div class="mb-1">
                  {{
                    orderReceipt.orderSellStatus === 6
                      ? (0 | currency: currency: 'symbol':'1.2-2')
                      : (orderReceipt.totalTip | currency: currency: 'symbol':'1.2-2')
                  }}
                </div>
              </div>
              <div class="f-20 fw-700 d-flex justify-content-between mb-3">
                <div class="mb-1">{{ "Total Amount" | translate | async }}</div>

                <div class="mb-1 paid_text">
                  {{
                    orderReceipt.orderSellStatus === 6
                      ? (0 | currency: currency: 'symbol':'1.2-2')
                      : (orderReceipt.totalAmount | currency: currency: 'symbol':'1.2-2')
                  }}
                </div>
              </div>
            </ng-container>
            <div
              class="row mt-2"
              *ngIf="!showRefundPageTwo && fundType == 'FULL REFUND'"
            >
              <div class="col-md-6"></div>
              <div class="col-md-6">
                <button
                  accessControl
                  module="Order"
                  access="3"
                  class="w-100 btn w-100 f-14 fw-600 red-btn bg-gray"
                  style="background-color: #d50000; color: #fff"
                  (click)="showRefundPageNex()"
                >
                  {{ "SELECT A REASON" | translate | async }}
                </button>
              </div>
            </div>
            <div
              class="row mt-2"
              *ngIf="!showRefundPageTwo && fundType == 'PARTIAL REFUND'"
            >
              <div class="col-md-6"></div>
              <div class="col-md-6">
                <button
                  [disabled]="refundProductList.length === 0"
                  class="w-100 btn w-100 f-14 fw-600 red-btn bg-gray"
                  style="background-color: #d50000; color: #fff"

                  (click)="showRefundPageNex()"
                >
                  {{ "SELECT A REASON" | translate | async }}
                </button>
              </div>
            </div>
            <div class="row" *ngIf="showRefundPageTwo">
              <div class="col-md-6 mb-3"></div>
              <div class="col-md-6 mb-3">
                <button
                  accessControl
                  module="Order"
                  access="3"
                  class="w-100 btn w-100 f-14 red-btn-theme fw-600 bg-gray"
                  (click)="refundOrder()"
                  [disabled]="refundReason === ''"
                >
                  {{ "REFUND" | translate | async }} -
                  {{
                    globalamount != 0
                      ? globalamount
                      : (orderReceipt.totalAmount
                        | currency : currency : "symbol" : "1.2-2")
                  }}
                </button>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </div>
  </ng-template>


  <ng-template #Editorder1 let-offcanvas>
    <div class="offcanvas-body">
      <div class="bill-details h-100 d-flex flex-column">
        <!-- Header: Display Order Details and Buttons -->
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h1 class="fw-700">{{ 'Edit Order' | translate | async }}</h1>
          <button type="button" class="btn-close" aria-label="Close" (click)="closeModal(Editorder); offcanvasService.dismiss('Cross click')"></button>
        </div>
  
        <!-- Order Details: Editable Fields -->
        <form [formGroup]="editOrderForm" (ngSubmit)="onSubmit()" class="edit-order-section mb-3">
          <div class="form-group mb-3">
            <label for="orderSellStatus">Order Sell Status</label>
            <select id="orderSellStatus" class="form-select" formControlName="orderSellStatus">
              <option *ngFor="let status of orderSellStatusList" [value]="status.value">
                {{ status.label }}
              </option>
            </select>
          </div>
  
          <div class="form-group mb-3">
            <label for="orderServeStatus">Order Serve Status</label>
            <select id="orderServeStatus" class="form-select" formControlName="orderServeStatus">
              <option *ngFor="let status of orderServeStatusList" [value]="status.value">
                {{ status.label }}
              </option>
            </select>
          </div>
  
          <div class="form-group mb-3">
            <label for="orderType">Order Type</label>
            <select id="orderType" class="form-select" formControlName="orderType">
              <option *ngFor="let status of orderTypeList" [value]="status.value">
                {{ status.label }}
              </option>
            </select>
          </div>
  
          <div class="form-group mb-3">
            <label for="paymentStatus">Payment Status</label>
            <select id="paymentStatus" class="form-select" formControlName="paymentStatus">
              <option *ngFor="let status of paymentStatusList" [value]="status.value">
                {{ status.label }}
              </option>
            </select>
          </div>
  
          <!-- <div class="form-group">
            <button type="submit" class="btn btn-primary">Save Changes</button>
          </div> -->
        </form>
  
        <!-- Transaction Table -->
        <div class="transaction-table mb-3">
          <h3 class="fw-600">{{ 'Transactions' | translate | async }}</h3>
          <table class="table">
            <thead>
              <tr>
                <th>{{ 'Transaction Number' | translate | async }}</th>
                <th>{{ 'Amount' | translate | async }}</th>
                <th>{{ 'Status' | translate | async }}</th>
                <th>{{ 'Type' | translate | async }}</th>
                <th>{{ 'Tip Amount' | translate | async }}</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let transaction of transactions.controls; let i=index" [formGroupName]="i">
                <td>{{ transaction.value.transactionNumber }}</td>
  
                <td (click)="editCell(i, 'transactionAmount')">
                  <ng-container *ngIf="editingTransactionIndex === i && editingField === 'transactionAmount'; else displayAmount">
                    <input type="number" formControlName="transactionAmount" (blur)="saveCell(i, 'transactionAmount')" class="form-control-sm" style="width: 100px;">
                  </ng-container>
                  <ng-template #displayAmount>
                    {{ transaction.value.transactionAmount }}
                  </ng-template>
                </td>
  
                <td (click)="editCell(i, 'transactionStatus')">
                  <ng-container *ngIf="editingTransactionIndex === i && editingField === 'transactionStatus'; else displayStatus">
                    <input type="number" formControlName="transactionStatus" (blur)="saveCell(i, 'transactionStatus')" class="form-control-sm" style="width: 100px;">
                  </ng-container>
                  <ng-template #displayStatus>
                    {{ transaction.value.transactionStatus }}
                  </ng-template>
                </td>
  
                <td (click)="editCell(i, 'transactionTypeId')">
                  <ng-container *ngIf="editingTransactionIndex === i && editingField === 'transactionTypeId'; else displayType">
                    <input type="number" formControlName="transactionTypeId" (blur)="saveCell(i, 'transactionTypeId')" class="form-control-sm" style="width: 100px;">
                  </ng-container>
                  <ng-template #displayType>
                    {{ transaction.value.transactionTypeId }}
                  </ng-template>
                </td>
  
                <td (click)="editCell(i, 'transactionTipAmount')">
                  <ng-container *ngIf="editingTransactionIndex === i && editingField === 'transactionTipAmount'; else displayTip">
                    <input type="number" formControlName="transactionTipAmount" (blur)="saveCell(i, 'transactionTipAmount')" class="form-control-sm" style="width: 100px;">
                  </ng-container>
                  <ng-template #displayTip>
                    {{ transaction.value.transactionTipAmount }}
                  </ng-template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #Editorder let-offcanvas>
    <div class="offcanvas-body">
      <div class="bill-details h-100 d-flex flex-column">
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h1 class="fw-700">{{ 'Edit Order' | translate  | async}}</h1>
          <button type="button" class="btn-close" aria-label="Close" (click)="closeModal(Editorder); offcanvasService.dismiss('Cross click')"></button>
        </div>
  
        <form [formGroup]="editOrderForm" (ngSubmit)="onSubmit()" class="edit-order-section mb-3">
          <div class="form-group mb-3">
            <label for="orderSellStatus">Order Sell Status</label>
            <select id="orderSellStatus" class="form-select" formControlName="orderSellStatus">
              <option *ngFor="let status of orderSellStatusList" [value]="status.value">
                {{ status.label }}
              </option>
            </select>
          </div>
          <div class="form-group mb-3">
            <label for="orderServeStatus">Order Serve Status</label>
            <select id="orderServeStatus" class="form-select" formControlName="orderServeStatus" >
              <option *ngFor="let status of orderServeStatusList" [value]="status?.value">
                {{ status?.label }}
              </option>
            </select>
          </div>
          <div class="form-group mb-3">
            <label for="orderType">Order Type</label>
            <select id="orderType" class="form-select" formControlName="orderType" disabled>
              <option *ngFor="let status of orderTypeList" [value]="status?.value">
                {{ status?.label }}
              </option>
            </select>
          </div>
          <div class="form-group mb-3">
            <label for="paymentStatus">Payment Status</label>
            <select id="paymentStatus" class="form-select" formControlName="paymentStatus">
              <option *ngFor="let status of paymentStatusList" [value]="status?.value">
                {{ status?.label }}
              </option>
            </select>
          </div>
  
        <div class="transaction-table mb-3">
          <h3 class="fw-600">{{ 'Transactions' | translate | async }}</h3>
          <table class="table">
            <thead>
              <tr>
                <th>{{ 'Transaction Number' | translate | async }}</th>
                <th>{{ 'Amount' | translate| async }}</th>
                <th>{{ 'Status' | translate| async }}</th>
                <th>{{ 'Type' | translate | async}}</th>
                <th>{{ 'Tip Amount' | translate | async }}</th>
                <th>{{ 'Actions' | translate | async }}</th>  
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let transaction of transactions?.controls; let i=index" [formGroupName]="transactions?.controls[i]">
                <td>{{ transactions.value[i].transactionNumber }}</td>
                <td (click)="editCell(i, 'transactionAmount')">
                  <ng-container *ngIf="editingTransactionIndex === i && editingField === 'transactionAmount'; else displayAmount">
                    <input type="number" [value]='transaction?.value?.transactionAmount' (blur)="saveCell(i, 'transactionAmount',$event.target.value)" class="form-control-sm" style="width: 100px;">
                  </ng-container>
                  <ng-template #displayAmount>
                    {{ transaction.value.transactionAmount }}
                  </ng-template>
                </td>
                <td (click)="editCell(i, 'transactionStatus')">
                  <ng-container *ngIf="editingTransactionIndex === i && editingField === 'transactionStatus'; else displayStatus">
                    <input type="number" [value]='transaction?.value?.transactionStatus' formControlName="transactionStatus" (blur)="saveCell(i, 'transactionStatus',$event.target.value)" class="form-control-sm" style="width: 100px;">
                  </ng-container>
                  <ng-template #displayStatus>
                    {{ transaction.value.transactionStatus }}
                  </ng-template>
                </td>
                <td (click)="editCell(i, 'transactionTypeId')">
                  <ng-container *ngIf="editingTransactionIndex === i && editingField === 'transactionTypeId'; else displayType">
                    <input type="number" [value]='transaction?.value?.transactionTypeId' formControlName="transactionTypeId" (blur)="saveCell(i, 'transactionTypeId',$event.target.value)" class="form-control-sm" style="width: 100px;" >
                  </ng-container>
                  <ng-template #displayType>
                    {{ transaction.value.transactionTypeId }}
                  </ng-template>
                </td>
                <td (click)="editCell(i, 'transactionTipAmount')">
                  <ng-container *ngIf="editingTransactionIndex === i && editingField === 'transactionTipAmount'; else displayTip">
                    <input type="number" [value]='transaction?.value?.transactionTipAmount' formControlName="transactionTipAmount" (blur)="saveCell(i, 'transactionTipAmount',$event.target.value)" class="form-control-sm" style="width: 100px;">
                  </ng-container>
                  <ng-template #displayTip>
                    {{ transaction.value.transactionTipAmount }}
                  </ng-template>
                </td>
                <td>
                  <div formArrayName="extraFields">
                    <!-- <div *ngFor="let extraField of getExtraFields(i).controls; let j=index" [formGroupName]="j">
                      <input formControlName="key" type="text" (keyup)="autoUpdate($event)" placeholder="Key"/>
                      <input formControlName="value" type="text" (keyup)="autoUpdate($event)" placeholder="Value"/>
                      <button type="button" (click)="removeExtraField(i, j)">Remove</button>
                    </div> -->
                    <button type="button" (click)="openExtraFieldsModal(i)" style="border:none; background-color: transparent;"> <i style="padding:2px"
                      [popoverTitle]="'Add extra fields' | translate | async"
                      triggers="mouseenter:mouseleave"
                      [ngbPopover]="'Add extra fields to edit order.' | translate | async"
                      placement="right"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        class="icon icon-tabler icon-tabler-plus"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        stroke-width="2"
                        stroke="currentColor"
                        fill="none"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                        <line x1="12" y1="5" x2="12" y2="19"></line>
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                      </svg>
                    </i></button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="onSubmit(); closeModal(Editorder); offcanvasService.dismiss('Cross click')">Save</button>
        </div>
      </form>

      </div>
    </div>
  </ng-template>
 <!-- Template for the Extra Fields Modal -->
 <ng-template #extraFieldsModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Add Extra Fields</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>

  </div>
  <div class="modal-body">
    <form [formGroup]="extraFieldForm">
      <div formArrayName="extraFields">
        <div *ngFor="let field of extraFields.controls; let i = index" [formGroupName]="i" class="form-row d-flex align-items-center gap-sm-2">
          <div class="form-group col-md-5">
            <label for="key-{{i}}">Key</label>
            <input formControlName="key" class="form-control" id="key-{{i}}" placeholder="Enter key">
          </div>
          <div class="form-group col-md-5">
            <label for="value-{{i}}">Value</label>
            <input formControlName="value" class="form-control" id="value-{{i}}" placeholder="Enter value">
          </div>
            <div class="d-flex align-items-end mb-2" style="margin-top: 8%;">
            <img
              src="assets\images\Shape (1).png"
              class="delete_icon"
              (click)="removeExtraField(i)"
            />
          </div>
        </div>
      </div>
      <button type="button" class="btn btn-secondary" (click)="addNewExtraField()" style="margin-top: 10px;">Add</button>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="saveExtraFields(); modal.close()">Save</button>
  </div>
</ng-template>
</div>
